import {
  message,
  Spin,
  Row,
  Col,
  Select,
  //Form as FormInitial,
  Space,
  PageHeader,
  Tooltip,
  Modal,
} from "antd";
import React, { Component } from "react";

import {
  MensajeError,
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    round6Decimals,
    dineroDisabledMask,
    ModalItem,
    InputItem,
    ButtonItem,
    ErrorItem,
    DatePickerItem,
    SelectInsumosItem,
    DisponibilidadInsumoModal,
    HistorialInsumoClienteModal,
    DetalleInsumoModal,
    BusquedaAvanzadaInsumosModal,
} from "../../../../Components/Items";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import { CommentOutlined,FileTextOutlined,DatabaseOutlined, DeleteOutlined, TagsOutlined,SwapOutlined, ArrowUpOutlined, ArrowDownOutlined, PlusOutlined, AppstoreOutlined, ProfileOutlined, FileExcelOutlined, WarningOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import ModalCargarExcelInsumos from "../../../../Components/ModalCargarExcelInsumos";
import {
    construirFilasInsumosDesdeExcel,
    insumosNuevosParaCatalogo,
    combinarFilasInsumos,
    payloadInventarioBulk,
    aplicarInventarioBulk,
} from "../../../../Components/cargarInsumosExcel.utils";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import MandarCorreoEmbarque from "../MandarCorreoEmbarque/MandarCorreoEmbarque";
import AgregarCliente from "../../Ventas/AgregarVenta/AgregarCliente/AgregarCliente";
import ElegirLeyenda from "../../Ventas/ElegirLeyenda/ElegirLeyenda";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirAgrupaciones from "../../Agrupaciones/ElegirAgrupaciones/ElegirAgrupaciones";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import VerInsumo from "../../Ventas/AgregarVenta/VerInsumo/VerInsumo";
import ElegirPedidoInsumo from "../ElegirPedidoInsumo/ElegirPedidoInsumo";
import embarquePdf from "../../../../Pdf/embarquePdf";
import VentasForm from "../../../../Components/VentasForm";
import AgregarCirugia from "../../Cirugias/AgregarCirugia/AgregarCirugia";
import AgregarDoctor from "../../Doctores/AgregarDoctor/AgregarDoctor";
import AgregarPaciente from "../../Pacientes/AgregarPaciente/AgregarPaciente";
import TabEntregaDireccion from "../../../../Components/TabEntregaDireccion";
import ModalAutorizacion from "../../../../Components/AutorizacionRapida/ModalAutorizacion";
import BotonAutorizacion from "../../../../Components/AutorizacionRapida/BotonAutorizacion";
import BotonDescripcionLarga, { textoDescripcionLarga } from "../../../../Components/BotonDescripcionLarga";
import { PERMISOS_AUTORIZABLES } from "../../../../Utils/autorizaciones";
import { crearReglasPrecio } from "../../../../Utils/reglasPrecioDocumento";
import {
    aplicarDescuentoBaseAFila,
    normalizarDescuentoFila,
    sincronizarDescuentoFila,
} from "../../../../Utils/descuentoEscuela";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
//const { TabPane } = Tabs;

class AgregarEmbarque extends Component {
    formRef = React.createRef();
    contadoAnterior = 1;
    precioIdAnterior = undefined;
    // Reglas de lista de precios: aviso en vivo, bloqueo al guardar y descuento
    // minimo automatico. Compartido con Ventas, Cotizaciones y Pedidos.
    reglas = crearReglasPrecio(this, {
        modulo: "EMBARQUE",
        recalcularTotales: (insumos) => this.recalcularInsumosEnBatch(insumos),
    });
    state = {
        loading: false,
        // Autorizaciones rápidas: clave "campo" → {autorizacionId, tokenConsumo}
        autorizacionesActivas: {},
        modalAutorizacion: null, // {visible, permisoId, clave, contexto}
        // Reglas de la lista de precios para este cliente; null = nada que revisar.
        contextoReglas: null,
        // Violaciones de rango por renglon: index -> {campo, motivo, limite, valor}
        fueraDeRango: {},
        objetoClientes: null,
        todasClientes: [],
        objetoProyectos: null,
        todasProyectos: null,
        objetoPrecios: null,
        todasPrecios: null,
        objetoInsumos: null,
        todasInsumos: [],
        modalCargarExcelVisible: false,
        objetoUsosDeCFDI: null,
        todasUsosDeCFDI: null,
        objetoBancos: null,
        todasBancos: null,
        objetoUsuarios: null,
        todasUsuarios: null,
        objetoMonedas: null,
        todasMonedas: null,
        impuestos: [],
        modalConfirmacion: false,
        modalCorreo: false,
        modalCorreoId: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteNombre: null,
        modalElegirTipoDeClienteId: null,
        valuesForm: null,
        entregarInsumos: false,
        totalPagar: 0,
        venderSinInventario: false,
        modalAgregar: false,
        objetoDoctores: null,
        todasDoctores: null,
        objetoPacientes: null,
        todasPacientes: null,
        modalLeyenda: false,
        modalLeyendaIndex: null,
        modalLeyendaLeyenda: null,
        modalLeyendaLeyendasPasadas: null,
        modalObservaciones: false,
        modalObservacionesIndex: null,
        modalObservacionesObservaciones: null,
        modalObservacionesObservacionesPasadas: null,
        modalObservacionesObservacionesXml: null,
        modalVerInsumo: false,
        modalVerInsumoId: null,
        modalVerInsumoPrecioId: null,
        modalVerInsumoIndex: 0,
        modalVerInsumoTipoDeCambio: 1,
        pedidosSeleccionados: this.props.location?.state?.pedidosSeleccionados || null,
        direccionesCliente: [],
        objetoDireccionesCliente: null,
        todasPaises: [],
        todasEstado: [],
        todasMunicipios: [],
        todasColonias: [],
        objetoPaises: null,
        objetoEstados: null,
        objetoMunicipios: null,
        objetoColonias: null,
        loadingEntrega: false,
        addendaMabe: false,
        loadingPlantasEntrega: false,
        tiposDescuento: {},
        docObligatorio : false,
        modalAgregarCirugia : false, 
        modalAgregarDoctor : false, 
        modalAgregarPaciente : false,
        cantidadDefault : false,
        modoReordenar: false,
        clienteIdActual: null, 
        nombreClienteActual: null,
        objetoCanalesVenta: null,
        todasCanalesVenta: [],
        modalElegirPedido: false,
        modalElegirPedidoIndex: null,
        modalElegirPedidoInsumoId: null,
        modalElegirPedidoCantidad: 0,
        modalElegirPedidoPedidosOrigen: [],
        modalDisponibilidadVisible: false,
        insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
        modalHistorialClienteVisible: false,
        insumoSeleccionadoHistorial: { id: null, nombre: '', clienteId: null, index: 0 },
        modalDetalleInsumoVisible: false,
        insumoSeleccionadoDetalle: { id: null, nombre: '' },
        modalBusquedaAvanzadaVisible: false,
        contextoBusquedaAvanzada: {},
        quitarImpuestos: false,
    };

    abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
        this.setState({
            modalDisponibilidadVisible: true,
            insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId }
        });
    }

    cerrarDisponibilidad = () => {
        this.setState({ modalDisponibilidadVisible: false });
    }

    abrirDetalleInsumo = (insumoId, nombre) => {
        if (!insumoId) return;
        this.setState({ modalDetalleInsumoVisible: true, insumoSeleccionadoDetalle: { id: insumoId, nombre } });
    }

    cerrarDetalleInsumo = () => {
        this.setState({ modalDetalleInsumoVisible: false });
    }

    // Boton "Busqueda avanzada" junto a "Agregar Insumo". El contexto es una foto del documento al
    // abrir; el modal lo manda igual que el SelectInsumosItem del renglon.
    abrirBusquedaAvanzada = () => {
        const form = this.formRef.current;
        if (!form) return;
        this.setState({
            modalBusquedaAvanzadaVisible: true,
            contextoBusquedaAvanzada: {
                // Igual que el select del renglon de Embarques: sin cliente, solo precio de lista.
                clienteId: null,
                precioId: form.getFieldValue("precioId"),
                proyectoId: form.getFieldValue("proyectoId"),
            },
        });
    }

    cerrarBusquedaAvanzada = () => {
        this.setState({ modalBusquedaAvanzadaVisible: false });
    }

    // Llena el primer renglon vacio o agrega uno, y corre el mismo onChangeInsumoProyecto que el
    // select del renglon. El modal espera esta promesa antes de dejar agregar otro: el handler
    // reescribe el arreglo completo y dos altas a la vez se pisarian. Vacio = sin insumo ni precio
    // ("Agregar Insumo" con cantidadDefault ya crea renglones con cantidad 1). El proyecto va explicito porque
    // el initialValue del renglon nuevo aun no se aplica cuando corre el handler.
    agregarInsumoDesdeBusqueda = async ({ insumo, cantidad }) => {
        const form = this.formRef.current;
        if (!form) return;
        const insumos = [...(form.getFieldValue("insumos") || [])];
        const proyectoId = form.getFieldValue("proyectoId");
        const insumoId = insumo._id?.toString();
        let indice = insumos.findIndex((fila) => !fila?.insumoId && !fila?.precioUnitario);
        if (indice === -1) {
            indice = insumos.length;
            insumos.push({ insumoId, cantidad, proyectoId });
        } else {
            insumos[indice] = { ...insumos[indice], insumoId, cantidad, proyectoId: insumos[indice]?.proyectoId || proyectoId };
        }
        form.setFieldsValue({ insumos });
        await this.onChangeInsumoProyecto(insumoId, indice, "insumo", false, insumo);
    }

    // Clic derecho en la misma celda donde el doble clic abre Disponibilidad.
    abrirHistorialCliente = (insumoId, nombre, index) => {
        if (!insumoId) return message.warning("Primero selecciona un insumo en el renglón");
        const clienteId = this.formRef.current?.getFieldValue("clienteId");
        if (!clienteId) return message.warning("Primero selecciona un cliente para ver su historial");
        this.setState({
            modalHistorialClienteVisible: true,
            insumoSeleccionadoHistorial: { id: insumoId, nombre, clienteId, index },
        });
    }

    // Mismo contrato que cerrarVerInsumo: si el modal devuelve un precio, se escribe en el
    // renglón y se dispara el recálculo canónico.
    cerrarHistorialCliente = async (precio) => {
        const index = this.state.insumoSeleccionadoHistorial.index;
        if (precio && precio > 0) {
            const insumos = await this.formRef.current.getFieldValue('insumos');
            // El precio del historial viene NETO (ya traia su descuento dentro), asi que se limpia el
            // descuento del renglon: si no, se descontaria dos veces y lo cobrado no seria lo que
            // mostraba el modal.
            const teniaDescuento = !!insumos[index]?.descuento || !!insumos[index]?.descuentoCantidad;
            insumos[index].precioUnitario = precio;
            insumos[index].descuento = 0;
            insumos[index].descuentoCantidad = 0;
            if (this.props.escuela) {
                insumos[index].descuentoBase = 0;
                insumos[index].descuentoAdicional = 0;
            }
            await this.formRef.current.setFieldsValue({ insumos });
            this.onChangePrecioCantidadDescuento(undefined, index);
            if (teniaDescuento) message.info("Se limpió el descuento del renglón: el precio del historial ya viene neto");
        }
        this.setState({ modalHistorialClienteVisible: false });
    }

    componentDidMount() {
        this.consultarTodo();
    }

    abrirAgregarCliente = () => {
        this.setState({ modalAgregar: true });
    };

    cerrarAgregarCliente = (id) => {
        this.setState({ modalAgregar: false });
        this.consultarTodo();
        if (id) {
            this.formRef.current.setFieldsValue({ clienteId: id })
        }
    };

     async consultarTodo() {
        this.setState({ loading: true });

        await axios
            .post(
                "embarques/selectDatosParaEmbarque",
                { empresaId: this.props.empresaId, pedidosSeleccionados: this.state.pedidosSeleccionados },
                {
                    headers: this.props.headersToken,
                }
            )
            .then(async (res) => {
                if (res.data.status === 404) {
                } else {
                    // Los pedidos con la orden de compra del cliente vencida
                    // (complemento PSW) no se precargan: avisar por que faltan.
                    if (res.data.pedidosVencidos?.length > 0) {
                        message.warn(
                            `No se incluyeron los pedidos con la orden de compra vencida: ${res.data.pedidosVencidos.join(", ")}`
                        );
                    }
                    this.setState({
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        ponerVendedor: res.data.ponerVendedor,
                        ponerCanal: res.data.ponerCanal,
                        ponerMetodoDePago: res.data.ponerMetodoDePago,
                        docObligatorio: res.data.docObligatorio,
                        cantidadDefault : res.data.cantidadDefault,
                        todasCanalesVenta: res.data.canalesVenta,
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoCanalesVenta: res.data.canalesVenta?.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                {value.nombre}
                                </Option>
                            );
                        }) || null,
                    });
                    if (res.data?.deshabilitarBanco) {
                        this.formRef.current.setFieldsValue({ deshabilitarBanco: res.data?.deshabilitarBanco });
                    }

                    if (res.data?.datosEmbarque?.clienteId) {
                        const responseCliente = await axios.post("clientes/buscarCliente", {
                            clienteId: res.data.datosEmbarque.clienteId,
                            empresaId: this.props.empresaId
                        }, { headers: this.props.headersToken })

                        if (responseCliente.data.success === 2) {
                            await this.setState({
                                addendaMabe: responseCliente.data.cliente.addendaMabe || false,
                                todasClientes: [responseCliente.data.cliente],
                                direccionesCliente: responseCliente.data.cliente.direcciones,
                                objetoDireccionesCliente: responseCliente.data.cliente.direcciones.map((value) => {
                                    return (
                                        <Option value={value._id} key={value._id}>
                                            {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                                        </Option>
                                    )
                                }),
                            })
                        } else {
                            return message.error('No se pudo obtener el cliente de la venta a duplicar')
                        }

                        const insumosAgregarTodos = res.data.datosEmbarque.insumosCatalogo || [];
                        if (insumosAgregarTodos.length === 0 && res.data?.datosEmbarque?.insumos?.length > 0) {
                            return message.error('No se pudieron obtener todos los insumos de la cotización');
                        }

                        const insumosFormat = res.data.datosEmbarque.insumos.map((insumo) => {
                            const divisor = insumo.cantidad > 0 ? insumo.cantidad : 1; 
                            const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / divisor);
                            return { 
                                ...insumo, 
                                precioUnitarioConImpuestos 
                            };
                        });

                        const tiposDescuentoIniciales = {};
                        insumosFormat.forEach((insumo, index) => {
                            if (insumo.descuentoCantidad && insumo.descuentoCantidad > 0) {
                                tiposDescuentoIniciales[index] = 'cantidad';
                            } else {
                                tiposDescuentoIniciales[index] = 'porcentaje';
                            }
                        });

                        this.setState({ tiposDescuento: tiposDescuentoIniciales, todasInsumos: insumosAgregarTodos, });

                        const insumosBulkPayload = insumosFormat.map((insumo, index) => {
                            const insumoIdString = insumo.insumoId?._id || insumo.insumoId;
                            const insumoOriginal = insumosAgregarTodos.find(
                                (i) => i._id.toString() === insumoIdString.toString()
                            );
                            return {
                                index: index,
                                insumoId: insumoIdString, 
                                proyectoId: insumo.proyectoId, 
                                inventariable: insumoOriginal?.inventariable,
                                noPrincipal: insumoOriginal?.noPrincipal,
                                insumoCompuesto: insumoOriginal?.insumoCompuesto,
                            };
                        });

                        try {
                            const resInventarios = await axios.post("inventarios/inventarioInsumoProyectoBulk", { 
                                empresaId: this.props.empresaId,
                                proyectoId: res.data.datosEmbarque?.proyectoId, 
                                pedidoId: this.state.id, 
                                insumos: insumosBulkPayload 
                            }, { headers: this.props.headersToken });
                            
                            if (resInventarios.data && resInventarios.data.results) {
                                resInventarios.data.results.forEach(resItem => {
                                    if (insumosFormat[resItem.index]) {
                                        insumosFormat[resItem.index].cantidadProyecto = 
                                            resItem.cantidad !== null ? resItem.cantidad : "No inventariable";
                                    }
                                });
                            }
                        } catch (error) {
                            console.error("Error al consultar inventario", error);
                        }

                        await this.formRef.current.setFieldsValue({
                            ...res.data.datosEmbarque,
                            factura: res.data.factura ? 1 : 2,
                            fechaPedido: res.data.fechaPedido
                                ? moment(res.data.fechaPedido)
                                : moment(res.data.createdAt),
                            insumos: insumosFormat
                        });
                        this.contadoAnterior = res.data.datosEmbarque.contado || 1;
                        this.precioIdAnterior = res.data.datosEmbarque.precioId;

                        this.recalcularInsumosEnBatch(insumosFormat);
    

                    }
                    if (res.data?.datosEmbarque?.direccionEntrega?.plantaEntregaId) {
                        this.onSearchPlantaEntrega(res.data?.datosEmbarque?.direccionEntrega?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
                    }
                }
            });

        if (this.props.equipoMedico) {

            await axios
                .post(
                    "ventas/selectDatosParaEquipoMedico",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            todasDoctores: res.data.doctores,
                            todasPacientes: res.data.pacientes,
                            todasCirugias: res.data.cirugias,
                            objetoDoctores: res.data.doctores.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoPacientes: res.data.pacientes.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoCirugias: res.data.cirugias.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                        });
                    } else {
                        message.error('No se encontraron datos de equipo medico')
                    }
                });

        }
        this.setState({ loading: false });

        // Al montar: el documento ya llega con cliente y lista, y sin esto se
        // quedaria sin reglas hasta que el usuario tocara uno de los dos.
        this.reglas.consultarContexto();
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        if (!values.insumos || values.insumos?.length === 0)
            return message.warning("Agregue insumos para agregar el embarque");

        // Rangos de la lista de precios. Si algo se sale y ese campo no esta
        // autorizado, se pide la autorizacion y se reanuda desde onAutorizado.
        // El backend valida lo mismo.
        const violacion = this.reglas.primeraSinAutorizar();
        if (violacion) {
            message.warning(violacion.motivo);
            this.abrirModalAutorizacion(violacion.campo, violacion.index, true);
            return;
        }

        this.setState({ loading: true });
        let insumos = values.insumos;
        let total = 0;
        let subtotal = 0;
        let arrayImpuestos = [];
        let arrayRetenciones = [];
        let cuentasCliente = 0;
        insumos.map((value) => {
            total += value.subtotal;
            subtotal += value.subtotal;
            value.arrayImpuestos.map((valueImpuestos) => {
                let index = arrayImpuestos.findIndex(
                    (valueImpuestosAnterios) =>
                        valueImpuestosAnterios.descripcionFactura ===
                        valueImpuestos.descripcionFactura
                        &&
                        valueImpuestosAnterios.tasaCuota ===
                        valueImpuestos.tasaCuota
                        &&
                        valueImpuestosAnterios.impuesto ===
                        valueImpuestos.impuesto
                );
                if (index !== -1) {
                    let newItem = {
                        totalImpuestos:
                            arrayImpuestos[index].totalImpuestos +
                            valueImpuestos.totalImpuestos,
                        baseImpuesto:
                            arrayImpuestos[index].baseImpuesto +
                            valueImpuestos.baseImpuesto,
                        descripcionFactura:
                            valueImpuestos.descripcionFactura,
                        tasaCuota:
                            valueImpuestos.tasaCuota,
                        impuesto:
                            valueImpuestos.impuesto,
                        montoImpuesto:
                            valueImpuestos.montoImpuesto,
                        local: valueImpuestos.local,
                    };
                    arrayImpuestos.splice(index, 1, newItem);
                } else {
                    arrayImpuestos.push({
                        tasaCuota: valueImpuestos.tasaCuota,
                        local: valueImpuestos.local,
                        impuesto: valueImpuestos.impuesto,
                        montoImpuesto: valueImpuestos.montoImpuesto,
                        baseImpuesto: valueImpuestos.baseImpuesto,
                        descripcionFactura: valueImpuestos.descripcionFactura,
                        totalImpuestos: valueImpuestos.totalImpuestos,
                    });
                }
                return null;
            });
            if (value.arrayRetenciones) {
                value.arrayRetenciones.map((valueRetenciones) => {
                    let index = arrayRetenciones.findIndex(
                        (valueRetencionesAnterios) =>
                            valueRetencionesAnterios.descripcionFactura ===
                            valueRetenciones.descripcionFactura
                            &&
                            valueRetencionesAnterios.tasaCuota ===
                            valueRetenciones.tasaCuota
                            &&
                            valueRetencionesAnterios.impuesto ===
                            valueRetenciones.impuesto
                    );
                    cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                    if (index !== -1) {
                        let newItem = {
                            totalRetenciones:
                                arrayRetenciones[index].totalRetenciones +
                                valueRetenciones.totalRetenciones,
                            baseRetencion:
                                arrayRetenciones[index].baseRetencion +
                                valueRetenciones.baseRetencion,
                            descripcionFactura:
                                valueRetenciones.descripcionFactura,
                            tasaCuota:
                                valueRetenciones.tasaCuota,
                            impuesto:
                                valueRetenciones.impuesto,
                            montoRetencion:
                                valueRetenciones.montoRetencion,
                            local: valueRetenciones.local,
                        };
                        arrayRetenciones.splice(index, 1, newItem);
                    } else {
                        arrayRetenciones.push({
                            tasaCuota: valueRetenciones.tasaCuota,
                            impuesto: valueRetenciones.impuesto,
                            montoRetencion: valueRetenciones.montoRetencion,
                            baseRetencion: valueRetenciones.baseRetencion,
                            local: valueRetenciones.local,
                            descripcionFactura: valueRetenciones.descripcionFactura,
                            totalRetenciones: valueRetenciones.totalRetenciones,
                        });
                    }
                    return null;
                });
            }
            return null;
        });
        arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
            total += round2Decimals(valueImpuesto.totalImpuestos)
            return {
                ...valueImpuesto,
                totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
            }
        })
        axios
            .post(
                "embarques/agregarEmbarque",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    pedidosSeleccionados: this.state.pedidosSeleccionados,
                    total,
                    subtotal,
                    cuentasCliente: round2Decimals(cuentasCliente),
                    totalPagar: round2Decimals(total - cuentasCliente),
                    arrayImpuestos,
                    arrayRetenciones,
                    autorizaciones: this.autorizacionesParaPayload(),
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado un embarque");
                    if (window.registrarMovimiento) {
                        const dataSat = res.data.respuestaFactura.dataSat
                        const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'P') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';
                        window.registrarMovimiento({
                            titulo: "Haga click para descargar",
                            mensaje: "Embarque Emitido",
                            icono: 2,
                            onClick: () => {
                                const pdf = embarquePdf(res.data);
                                pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                            },
                        });
                    }
                    this.setState({
                        modalCorreo: true,
                        modalCorreoId: res.data.embarqueId,
                    });
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar el embarque",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y el embarque no se registro");
                }
            });
    }
    atras() {
        this.props.history.goBack();
    }

    recalcularInsumosEnBatch(insumosFormat) {
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        const tipoDeCambio = this.formRef.current.getFieldValue("tipoDeCambio");
        const noTax = this.state.quitarImpuestos;
        const arrayValue = [...insumosFormat];

        arrayValue.forEach((item, key) => {
            if (this.props.escuela) normalizarDescuentoFila(item);
            const insumoId = item.insumoId?._id || item.insumoId;
            const insumo = this.state.todasInsumos.find(
                (v) => v._id.toString() === insumoId?.toString()
            );
            if (!insumo) return;

            const precioUnitario = Number(item.precioUnitario);

            let totalImpuestosPrecioSinImpuestos = 0;
            if (!noTax) {
                insumo.impuestos.forEach((valueImpuesto) => {
                    let totalImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (valueImpuesto.monto / 100);
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = valueImpuesto.monto / tipoDeCambio;
                    } else {
                        totalImpuesto = 0;
                    }
                    totalImpuestosPrecioSinImpuestos += totalImpuesto;
                });
            }
            arrayValue[key].precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos);

            const cantidad = item.cantidad;
            const descuento = item.descuento || 0;
            const descuentoCantidad = item.descuentoCantidad || 0;

            if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
                const subtotal = round6Decimals(cantidad * precioUnitario);
                const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
                const totalEntrada = round6Decimals(subtotal - totalDescuento);
                arrayValue[key].subtotal = totalEntrada;

                let totalImpuestos = 0;
                let arrayImpuestos = [];
                if (!noTax) {
                    arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
                        let totalImpuesto, baseImpuesto, montoImpuesto;
                        if (valueImpuesto.tasaCuota === 1) {
                            totalImpuesto = round6Decimals(totalEntrada * (valueImpuesto.monto / 100));
                            baseImpuesto = totalEntrada;
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                        } else if (valueImpuesto.tasaCuota === 2) {
                            totalImpuesto = round6Decimals((totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100));
                            baseImpuesto = totalEntrada + totalImpuestos;
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                        } else if (valueImpuesto.tasaCuota === 3) {
                            totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                            baseImpuesto = cantidad;
                            montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio);
                        } else {
                            totalImpuesto = 0; baseImpuesto = totalEntrada; montoImpuesto = 0;
                        }
                        totalImpuestos += totalImpuesto;
                        return { tasaCuota: valueImpuesto.tasaCuota, impuesto: valueImpuesto.impuesto, montoImpuesto, local: valueImpuesto.local, baseImpuesto, descripcionFactura: valueImpuesto.descripcionFactura, totalImpuestos: totalImpuesto };
                    });
                }
                arrayValue[key].impuestos = totalImpuestos;
                arrayValue[key].arrayImpuestos = arrayImpuestos;
                arrayValue[key].total = round2Decimals(totalEntrada + totalImpuestos);

                if (!noTax && clienteId) {
                    const cliente = this.state.todasClientes?.find((v) => v._id === clienteId);
                    if (cliente) {
                        let totalRetenciones = 0;
                        const arrayRetenciones = [];
                        [...cliente.retenciones, ...insumo.retenciones.filter(r =>
                            (r.aplicaVenta === 1 && !cliente.persona) ||
                            (r.aplicaVenta === 2 && cliente.persona) ||
                            r.aplicaVenta === 3
                        )].forEach((valueRetencion) => {
                            let totalRetencion, baseRetencion;
                            if (valueRetencion.tasaCuota === 1) {
                                totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                                baseRetencion = totalEntrada;
                            } else if (valueRetencion.tasaCuota === 2) {
                                totalRetencion = round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                                baseRetencion = totalEntrada + totalImpuestos;
                            }
                            totalRetenciones += totalRetencion;
                            arrayRetenciones.push({ tasaCuota: valueRetencion.tasaCuota, impuesto: valueRetencion.impuesto, montoRetencion: valueRetencion.monto, local: valueRetencion.local, baseRetencion, descripcionFactura: valueRetencion.descripcionFactura, totalRetenciones: totalRetencion });
                        });
                        arrayValue[key].retenciones = totalRetenciones;
                        arrayValue[key].arrayRetenciones = arrayRetenciones;
                    }
                } else if (noTax) {
                    arrayValue[key].retenciones = 0;
                    arrayValue[key].arrayRetenciones = [];
                }
            }
        });

        this.formRef.current.setFieldsValue({ insumos: arrayValue });
    }

    // Un renglon con pedidosOrigen tiene el vinculo al Pedido del que sale, y ese
    // vinculo solo vive en el renglon: reemplazar la lista lo borraria sin manera de
    // recuperarlo, asi que en ese caso el modal solo deja agregar al final.
    hayRenglonesConPedidoAsignado = () =>
        (this.formRef.current?.getFieldValue("insumos") || []).some(
            (valueInsumo) => valueInsumo?.pedidosOrigen?.length > 0
        );

    // Carga masiva desde Excel: arma todos los renglones y los aplica con un solo
    // setFieldsValue (via recalcularInsumosEnBatch) en vez de un add() por renglon.
    cargarInsumosDesdeExcel = async (filasValidas, modo) => {
        const proyectoId = this.formRef.current.getFieldValue("proyectoId");
        const precioId = this.formRef.current.getFieldValue("precioId");
        const usarPrecioCliente = this.formRef.current.getFieldValue("usarPrecioCliente") !== false;

        const insumosNuevos = insumosNuevosParaCatalogo(filasValidas, this.state.todasInsumos);
        if (insumosNuevos.length > 0) {
            await new Promise((resolve) =>
                this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, ...insumosNuevos] }), resolve)
            );
        }

        const filasNuevas = construirFilasInsumosDesdeExcel({
            filas: filasValidas,
            proyectoId,
            precioId,
            usarPrecioCliente,
        });

        try {
            const resInventarios = await axios.post(
                "inventarios/inventarioInsumoProyectoBulk",
                {
                    empresaId: this.props.empresaId,
                    proyectoId,
                    insumos: payloadInventarioBulk(filasValidas, proyectoId),
                },
                { headers: this.props.headersToken }
            );
            aplicarInventarioBulk(filasNuevas, resInventarios.data?.results);
        } catch (error) {
            console.error("Error al consultar inventario en batch:", error);
        }

        const insumosActuales = this.formRef.current.getFieldValue("insumos") || [];
        // Si hay renglones con pedido asignado nunca se reemplaza, aunque llegara ese
        // modo: el modal ya lo esconde, esto es la red de seguridad.
        const modoSeguro = this.hayRenglonesConPedidoAsignado() ? "agregar" : modo;
        const filasFinales = combinarFilasInsumos(insumosActuales, filasNuevas, modoSeguro);

        this.recalcularInsumosEnBatch(filasFinales);
        this.setState({ modalCargarExcelVisible: false });
        message.success(`${filasNuevas.length} línea(s) cargada(s) desde Excel.`);
    };

    async onChangeInsumoProyecto(inicial, key, tipo, noPonerPrecio, insumoEncontrado) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let precioId = await this.formRef.current.getFieldValue("precioId");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const noTax = this.state.quitarImpuestos;
        let proyectoId = arrayValue[key].proyectoId;
        const insumoId = arrayValue[key].insumoId;
        let insumo
        if (insumoEncontrado) {
            insumo = insumoEncontrado;
            const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
            if (!yaExiste) {
                await this.setState(prev => ({
                    todasInsumos: [...prev.todasInsumos, insumo]
                }));
            }
        } else {
            insumo = this.state.todasInsumos.find(
                (valueInsumos) => valueInsumos._id === insumoId
            );
        }
        // if(tipo === 'insumo'){
        //   function getAllIndexes(arr, val) {
        //     var indexes = [], i = -1;
        //     while ((i = arr.indexOf(val, i+1)) != -1){
        //         indexes.push(i);
        //     }
        //     return indexes;
        // }
        // }
        if (!insumo) return;
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].cantidadProyecto = res.data.cantidad;
                });
        } else {
            arrayValue[key].cantidadProyecto = "No inventariable";
        }
        if (tipo === "insumo") {
            // Otro producto: la descripcion larga vuelve al default de su catalogo.
            arrayValue[key].imprimirDescripcionLarga = undefined;
            const precio = insumo.precios.find(
                (valuePrecios) => valuePrecios.precioId?.toString() === precioId
            );
            if (!noPonerPrecio) {
                if (precio) {
                    arrayValue[key].precioUnitario = precio.precio;
                } else {
                    message.info("Este insumo no tiene ese precio");
                    arrayValue[key].precioUnitario = 0;
                }
            }
        }

        // Complemento Escuela: el insumo elegido trae el descuento predeterminado del
        // cliente como base. Sin poner precio se respeta el que traia.
        if (this.props.escuela) {
            if (tipo === "insumo" && !noPonerPrecio) {
                aplicarDescuentoBaseAFila(arrayValue[key], this.descuentoPredeterminadoCliente());
            } else {
                normalizarDescuentoFila(arrayValue[key]);
            }
        }

        // Descuento minimo de la lista, ya acotado por el margen minimo. Va antes
        // de que se lea `descuento` mas abajo para que el subtotal salga bien en
        // esta misma pasada; solo toca renglones que estan en 0.
        this.reglas.aplicarDescuentoMinimoAFila(key, arrayValue[key]);

        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        if (!noTax) {
            insumo.impuestos.map((valueImpuesto) => {
                let totalImpuesto;
                if (valueImpuesto.tasaCuota === 1) {
                    totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 2) {
                    totalImpuesto =
                        (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                        (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 3) {
                    totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
                } else if (valueImpuesto.tasaCuota === 5) {
                    totalImpuesto = 0
                }
                totalImpuestosPrecioSinImpuestos += totalImpuesto;
                return null;
            });
        }
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );

        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;
        const descuentoCantidad = arrayValue[key].descuentoCantidad || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = [];
            if (!noTax) arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (!noTax && clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })

                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            } else if (noTax) {
                arrayValue[key].retenciones = 0;
                arrayValue[key].arrayRetenciones = [];
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
        this.reglas.actualizarFila(key);
    }
    async onChangePrecioCantidadDescuento(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const noTax = this.state.quitarImpuestos;
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        if (!noTax) {
            insumo.impuestos.map((valueImpuesto) => {
                let totalImpuesto;
                if (valueImpuesto.tasaCuota === 1) {
                    totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 2) {
                    totalImpuesto =
                        (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                        (valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 3) {
                    totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
                } else if (valueImpuesto.tasaCuota === 5) {
                    totalImpuesto = 0
                }
                totalImpuestosPrecioSinImpuestos += totalImpuesto;
                return null;
            });
        }
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;
        const descuentoCantidad = arrayValue[key].descuentoCantidad || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(((subtotal * (descuento / 100)) || 0) + descuentoCantidad);
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = [];
            if (!noTax) {
                arrayImpuestos = insumo.impuestos.map(
                    //4
                    (valueImpuesto) => {
                        let totalImpuesto;
                        let baseImpuesto;
                        let montoImpuesto;
                        if (valueImpuesto.tasaCuota === 1) {
                            totalImpuesto = round6Decimals(
                                totalEntrada * (valueImpuesto.monto / 100)
                            );
                            baseImpuesto = totalEntrada
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                        } else if (valueImpuesto.tasaCuota === 2) {
                            totalImpuesto = round6Decimals(
                                (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                            );
                            baseImpuesto = (totalEntrada + totalImpuestos)
                            montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                        } else if (valueImpuesto.tasaCuota === 3) {
                            totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                            baseImpuesto = cantidad
                            montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                        } else if (valueImpuesto.tasaCuota === 5) {
                            totalImpuesto = 0
                            baseImpuesto = totalEntrada
                            montoImpuesto = 0
                        }
                        totalImpuestos += totalImpuesto;
                        return {
                            tasaCuota: valueImpuesto.tasaCuota,
                            impuesto: valueImpuesto.impuesto,
                            montoImpuesto: montoImpuesto,
                            local: valueImpuesto.local,
                            baseImpuesto: baseImpuesto,
                            descripcionFactura: valueImpuesto.descripcionFactura,
                            totalImpuestos: totalImpuesto,
                        };
                    }
                );
            }
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (!noTax && clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            } else if (noTax) {
                arrayValue[key].retenciones = 0;
                arrayValue[key].arrayRetenciones = [];
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
        this.reglas.actualizarFila(key);
    }
    onChangePrecioConImpuestos = async (value, key) => {
        if (value === undefined || value === null || value === "") return;

        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        const noTax = this.state.quitarImpuestos;

        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;

        // Inversa correcta del precio con impuestos
        // Con impuestos quitados no hay nada que revertir: el precio neto capturado ES el precio unitario
        let factor = 1;
        let sumaCuotasFijas = 0;

        if (!noTax) {
            insumo.impuestos.forEach((valueImpuesto) => {
                const porcentaje = valueImpuesto.monto / 100;

                if (valueImpuesto.tasaCuota === 1) {
                    // porcentaje sobre base
                    factor += porcentaje;
                } else if (valueImpuesto.tasaCuota === 2) {
                    // porcentaje sobre base + impuestos acumulados
                    factor *= (1 + porcentaje);
                } else if (valueImpuesto.tasaCuota === 3) {
                    // cuota fija
                    sumaCuotasFijas += valueImpuesto.monto / tipoDeCambio;
                }
            });
        }

        const precioUnitario = round6Decimals(
            (Number(value) - sumaCuotasFijas) / factor
        );

        arrayValue[key].precioUnitario = precioUnitario;

        const cantidad = Number(arrayValue[key].cantidad || 0);
        const descuento = Number(arrayValue[key].descuento || 0);
        const descuentoCantidad = Number(arrayValue[key].descuentoCantidad || 0);

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            const subtotal = round6Decimals(cantidad * precioUnitario);
            const totalDescuento = round6Decimals(
                ((subtotal * (descuento / 100)) || 0) + descuentoCantidad
            );
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = [];
            if (!noTax) arrayImpuestos = insumo.impuestos.map((valueImpuesto) => {
                let totalImpuesto = 0;
                let baseImpuesto = 0;
                let montoImpuesto = 0;

                if (valueImpuesto.tasaCuota === 1) {
                    totalImpuesto = round6Decimals(
                        totalEntrada * (valueImpuesto.monto / 100)
                    );
                    baseImpuesto = totalEntrada;
                    montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 2) {
                    baseImpuesto = totalEntrada + totalImpuestos;
                    totalImpuesto = round6Decimals(
                        baseImpuesto * (valueImpuesto.monto / 100)
                    );
                    montoImpuesto = round6Decimals(valueImpuesto.monto / 100);
                } else if (valueImpuesto.tasaCuota === 3) {
                    totalImpuesto = round6Decimals(
                        (cantidad * valueImpuesto.monto) / tipoDeCambio
                    );
                    baseImpuesto = cantidad;
                    montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio);
                } else if (valueImpuesto.tasaCuota === 5) {
                    totalImpuesto = 0;
                    baseImpuesto = totalEntrada;
                    montoImpuesto = 0;
                }

                totalImpuestos += totalImpuesto;

                return {
                    tasaCuota: valueImpuesto.tasaCuota,
                    impuesto: valueImpuesto.impuesto,
                    montoImpuesto,
                    local: valueImpuesto.local,
                    baseImpuesto,
                    descripcionFactura: valueImpuesto.descripcionFactura,
                    totalImpuestos: totalImpuesto,
                };
            });

            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (!noTax && clienteId) {
                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );

                if (cliente) {
                    let totalRetenciones = 0;
                    let arrayRetenciones = [];

                    cliente.retenciones.forEach((valueRetencion) => {
                        let totalRetencion = 0;
                        let baseRetencion = 0;

                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(
                                totalEntrada * (valueRetencion.monto / 100)
                            );
                            baseRetencion = totalEntrada;
                        } else if (valueRetencion.tasaCuota === 2) {
                            baseRetencion = totalEntrada + totalRetenciones;
                            totalRetencion = round6Decimals(
                                baseRetencion * (valueRetencion.monto / 100)
                            );
                        }

                        totalRetenciones += totalRetencion;

                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    });

                    insumo.retenciones.forEach((valueRetencion) => {
                        if (
                            (valueRetencion.aplicaVenta === 1 && cliente.persona === false) ||
                            (valueRetencion.aplicaVenta === 2 && cliente.persona === true) ||
                            valueRetencion.aplicaVenta === 3
                        ) {
                            let totalRetencion = 0;
                            let baseRetencion = 0;

                            if (valueRetencion.tasaCuota === 1) {
                                totalRetencion = round6Decimals(
                                    totalEntrada * (valueRetencion.monto / 100)
                                );
                                baseRetencion = totalEntrada;
                            } else if (valueRetencion.tasaCuota === 2) {
                                baseRetencion = totalEntrada + totalRetenciones;
                                totalRetencion = round6Decimals(
                                    baseRetencion * (valueRetencion.monto / 100)
                                );
                            }

                            totalRetenciones += totalRetencion;

                            arrayRetenciones.push({
                                tasaCuota: valueRetencion.tasaCuota,
                                impuesto: valueRetencion.impuesto,
                                montoRetencion: valueRetencion.monto,
                                local: valueRetencion.local,
                                baseRetencion,
                                descripcionFactura: valueRetencion.descripcionFactura,
                                totalRetenciones: totalRetencion,
                            });
                        }
                    });

                    arrayValue[key].retenciones = totalRetenciones;
                    arrayValue[key].arrayRetenciones = arrayRetenciones;
                }
            } else if (noTax) {
                arrayValue[key].retenciones = 0;
                arrayValue[key].arrayRetenciones = [];
            }
        }

        // conservar lo capturado por el usuario
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(Number(value));

        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
        this.reglas.actualizarFila(key);
    }
    onDobleClickDescuento = (arrayKey) => {
        this.setState(prev => ({
            tiposDescuento: {
                ...prev.tiposDescuento,
                [arrayKey]: prev.tiposDescuento[arrayKey] === 'cantidad' ? 'porcentaje' : 'cantidad'
            }
        }), () => {
            const insumos = this.formRef.current.getFieldValue('insumos')
            if (this.state.tiposDescuento[arrayKey] === 'cantidad') {
                if (this.props.escuela) {
                    // El Desc. Cliente se queda; solo se limpia el adicional en %.
                    insumos[arrayKey].descuentoAdicional = 0
                    sincronizarDescuentoFila(insumos[arrayKey])
                } else {
                    insumos[arrayKey].descuento = 0
                }
            } else {
                insumos[arrayKey].descuentoCantidad = 0
            }
            this.formRef.current.setFieldsValue({ insumos })
            this.onChangePrecioCantidadDescuento(0, arrayKey)
        })
    }
    // Complemento Escuela: % predeterminado del cliente seleccionado.
    descuentoPredeterminadoCliente = () => {
        const clienteId = this.formRef.current?.getFieldValue("clienteId");
        if (!clienteId) return 0;
        const cliente = this.state.todasClientes.find(
            (valueCliente) => valueCliente._id?.toString() === clienteId.toString()
        );
        return cliente?.descuentoPredeterminado || 0;
    }
    // Complemento Escuela: Desc. Cliente y Desc. Adic. alimentan `descuento` (su
    // cascada), que es el unico que entra en el calculo.
    onChangeDescuentoEscuela = (arrayKey) => {
        const insumos = this.formRef.current.getFieldValue("insumos");
        sincronizarDescuentoFila(insumos[arrayKey]);
        this.formRef.current.setFieldsValue({ insumos });
        this.onChangePrecioCantidadDescuento(undefined, arrayKey);
    }
    async onChangeCliente(valueId, clienteEncontrado) {
        let contado = this.formRef.current.getFieldValue("contado");
        this.setState({ loading: true });
        let cliente
        if (clienteEncontrado) {
            cliente = clienteEncontrado;
            const yaExiste = this.state.todasClientes.find(i => i._id === cliente._id);
            if (!yaExiste) {
                await this.setState(prev => ({
                    todasClientes: [...prev.todasClientes, cliente]
                }));
            }
        } else {
            cliente = this.state.todasClientes.find(
                (valueClientes) => valueClientes._id === valueId
            );
        }
        this.setState({ loading: false });
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.usoDeCFDIID) {
            objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID
        }
        if (cliente.contado && this.state.ponerMetodoDePago) {
            objetoCambiar.contado = cliente.contado
            contado = cliente.contado
            this.onChangeContado(cliente.contado, true)
            message.info('Se actualizo el metodo de pago')
        }
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        if (cliente.vendedorId && this.state.ponerVendedor && this.state.todasUsuarios?.find(u => u._id?.toString() === cliente.vendedorId?.toString())) {
            objetoCambiar.vendedorId = cliente.vendedorId
        }
        if (cliente.canalDeVentaId && this.state.ponerCanal && this.state.todasCanalesVenta?.find(c => c._id?.toString() === cliente.canalDeVentaId?.toString())) {
            objetoCambiar.canalDeVentaId = cliente.canalDeVentaId
        }
        if (cliente.monedaId){
            objetoCambiar.monedaId = cliente.monedaId
            this.onChangeMoneda(cliente.monedaId)
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            },
            direccionesCliente: cliente.direcciones,
            objetoDireccionesCliente: cliente.direcciones.map((value) => {
                return (
                    <Option value={value._id} key={value._id}>
                        {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                    </Option>
                )
            }),
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
        this.contadoAnterior = this.formRef.current.getFieldValue("contado");
        this.precioIdAnterior = this.formRef.current.getFieldValue("precioId");
        // Las reglas dependen del cliente y de su tipo de cliente.
        this.reglas.consultarContexto(valueId, this.precioIdAnterior);
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (insumos?.length > 0) {
            // Complemento Escuela: el Desc. Cliente pasa a ser el del cliente nuevo y el
            // adicional se queda. Esta pantalla solo llama aqui desde el select.
            if (this.props.escuela) {
                insumos.forEach((fila) => {
                    if (fila?.insumoId) aplicarDescuentoBaseAFila(fila, cliente.descuentoPredeterminado);
                });
            }
            this.recalcularInsumosEnBatch(insumos);
        }
        if(cliente?.usarAdenda && cliente?.adendaActiva === "Mabe"){
            this.setState({ addendaMabe: true });
        }

    }
    // Bloquea con los permisos especificos de Pedidos (que son los que gobiernan
    // los inputs de esta pantalla) y autoriza contra los genericos, que son los
    // unicos que estan en PERMISOS_AUTORIZABLES.
    estaBloqueado = (campo, index) => {
        const permisoProp = {
            precioUnitario: "permisoModificarPrecioUnitarioPedidos",
            descuento: "permisoModificarDescuentosPedidos",
            listaPrecios: "permisoModificarListaPreciosPedidos",
        }[campo];
        const clave = index !== undefined && index !== null ? `${campo}:${index}` : campo;
        return !this.props[permisoProp] && !this.state.autorizacionesActivas[clave]?.accesoLibre;
    };

    tieneInsumoSeleccionado = (index) =>
        !!this.formRef.current?.getFieldValue(["insumos", index, "insumoId"]);

    abrirModalAutorizacion = (campo, index, reanudarGuardado) => {
        const definicion = PERMISOS_AUTORIZABLES[campo];
        if (!definicion) return;
        const clave = index !== undefined && index !== null ? `${campo}:${index}` : campo;
        let contexto = { modulo: "EMBARQUE", campo, descripcion: definicion.etiqueta };

        if (index !== undefined && index !== null) {
            const insumos = this.formRef.current?.getFieldValue("insumos") || [];
            const item = insumos[index] || {};
            const insumoOriginal = this.state.todasInsumos.find((i) => i._id === item.insumoId);
            const insumoNombre = insumoOriginal?.nombre || insumoOriginal?.descripcion || "";
            contexto = {
                ...contexto,
                insumoId: item.insumoId,
                insumoNombre,
                valorActual:
                    campo === "descuento"
                        ? item.descuento ?? item.descuentoCantidad ?? 0
                        : item.precioUnitario,
                tipoDescuento: campo === "descuento" ? this.state.tiposDescuento[index] : undefined,
                descripcion: `${definicion.etiqueta}${insumoNombre ? ` — ${insumoNombre}` : ""}`,
            };
        } else if (campo === "listaPrecios") {
            const clienteId = this.formRef.current?.getFieldValue("clienteId");
            const cliente = this.state.todasClientes?.find((c) => c._id === clienteId);
            const clienteNombre = cliente
                ? cliente.persona
                    ? cliente.razonSocial || ""
                    : `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim()
                : "";
            const precioIdActual = this.formRef.current?.getFieldValue("precioId");
            const precioActual = this.state.todasPrecios?.find((p) => p._id === precioIdActual);
            contexto = {
                ...contexto,
                valorActual: precioActual?.nombre || undefined,
                descripcion: `${definicion.etiqueta}${clienteNombre ? ` — ${clienteNombre}` : ""}`,
            };
        }

        this.setState({
            modalAutorizacion: { visible: true, permisoId: definicion.permisoId, campo, index, clave, contexto, reanudarGuardado },
        });
    };
    onAutorizado = async (datos) => {
        const { modalAutorizacion } = this.state;
        if (!modalAutorizacion) return;
        const { campo, index } = modalAutorizacion;
        if (!datos.accesoLibre && datos.valorSolicitado !== undefined && datos.valorSolicitado !== null) {
            if (index !== undefined && index !== null) {
                const insumos = this.formRef.current.getFieldValue("insumos") || [];
                const campoDestino =
                    campo === "descuento"
                        ? (this.state.tiposDescuento[index] === "cantidad"
                            ? "descuentoCantidad"
                            : (this.props.escuela ? "descuentoAdicional" : "descuento"))
                        : campo;
                insumos[index] = { ...insumos[index], [campoDestino]: datos.valorSolicitado };
                if (this.props.escuela && campo === "descuento") sincronizarDescuentoFila(insumos[index]);
                this.formRef.current.setFieldsValue({ insumos });
            } else if (campo === "listaPrecios") {
                this.formRef.current.setFieldsValue({ precioId: datos.valorSolicitado });
                this.precioIdAnterior = datos.valorSolicitado;
                const insumos = this.formRef.current.getFieldValue("insumos");
                if (insumos?.length > 0) {
                    message.info("Se actualizaron los precios de los insumos según la nueva lista de precios autorizada.");
                    this.recalcularPreciosTodosLosInsumos(datos.valorSolicitado);
                }
                this.reglas.consultarContexto(undefined, datos.valorSolicitado);
            }
        }
        this.setState(
            {
                autorizacionesActivas: {
                    ...this.state.autorizacionesActivas,
                    [modalAutorizacion.clave]: datos,
                },
                modalAutorizacion: null,
            },
            () => {
                // Si la autorizacion venia del bloqueo al guardar, se reanuda ahora
                // que el campo ya esta cubierto. Se llama al onFinish real, NO al
                // modal de confirmacion: el usuario ya confirmo una vez.
                if (!modalAutorizacion.reanudarGuardado) return;
                if (this.reglas.primeraSinAutorizar()) return;
                this.onFinish(this.state.valuesForm);
            }
        );
    };

    autorizacionesParaPayload = () =>
        Object.values(this.state.autorizacionesActivas).map((a) => ({
            autorizacionId: a.autorizacionId,
            tokenConsumo: a.tokenConsumo,
        }));

    onChangePrecioId = (value) => {
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (!insumos || insumos.length === 0) {
            this.precioIdAnterior = value;
            this.reglas.consultarContexto(undefined, value);
            return;
        }
        const anterior = this.precioIdAnterior;
        Modal.confirm({
            title: "Cambiar lista de precios",
            content: "Este embarque ya tiene insumos agregados. Cambiar la lista de precios actualizará los precios e importes de todos los insumos ya agregados. ¿Deseas continuar?",
            okText: "Sí, actualizar precios",
            cancelText: "Cancelar",
            onOk: () => {
                this.precioIdAnterior = value;
                this.recalcularPreciosTodosLosInsumos(value);
                // Cada lista trae sus reglas y su descuento minimo.
                this.reglas.consultarContexto(undefined, value);
            },
            onCancel: () => {
                this.formRef.current.setFieldsValue({ precioId: anterior });
            },
        });
    };

    // Aplica la nueva lista de precios a todas las filas y delega el recálculo de
    // impuestos/retenciones/total en recalcularInsumosEnBatch (un solo setFieldsValue).
    // A diferencia de Pedidos y Ventas, aqui NO se considera el precio alternativo
    // del cliente: Embarques nunca lo ha usado.
    recalcularPreciosTodosLosInsumos = (precioId) => {
        const insumos = this.formRef.current.getFieldValue("insumos");
        if (!insumos || insumos.length === 0) return;

        let sinPrecio = 0;
        const nuevosInsumos = insumos.map((fila) => {
            const insumoId = fila.insumoId?._id || fila.insumoId;
            const insumo = this.state.todasInsumos.find((i) => i._id.toString() === insumoId?.toString());
            if (!insumo) return fila;

            const precio = insumo.precios.find((p) => p.precioId?.toString() === precioId);
            if (!precio) sinPrecio++;
            return { ...fila, precioUnitario: precio ? precio.precio : 0 };
        });

        this.recalcularInsumosEnBatch(nuevosInsumos);
        if (sinPrecio > 0) {
            message.info(`${sinPrecio} insumo(s) no tienen precio en esta lista y se dejaron en $0.`);
        }
    };

    onChangeContado(value, inicial) {
        const insumos = this.formRef.current.getFieldValue("insumos");
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        const cliente = clienteId && this.state.todasClientes.find(
            (valueProv) => valueProv._id === clienteId
        );
        const nuevoPrecioId = cliente ? (value === 1 ? cliente.precioContadoId : cliente.precioCreditoId) : null;
        const precioIdActual = this.formRef.current.getFieldValue("precioId");
        const esCambioReal = !inicial || !!inicial?.children;

        if (esCambioReal && insumos?.length > 0
            && !(this.state.pedidosSeleccionados?.length > 0)
            && clienteId && nuevoPrecioId && nuevoPrecioId !== precioIdActual) {
            const anterior = this.contadoAnterior;
            Modal.confirm({
                title: value === 1 ? "Cambiar a Contado" : "Cambiar a Crédito",
                content: "Este embarque ya tiene insumos agregados. Cambiar el método actualizará la lista de precios y, con ella, los precios e importes de los insumos ya agregados. ¿Deseas continuar?",
                okText: "Sí, actualizar precios",
                cancelText: "Cancelar",
                onOk: () => {
                    this.contadoAnterior = value;
                    this.precioIdAnterior = nuevoPrecioId;
                    this.formRef.current.setFieldsValue({ precioId: nuevoPrecioId });
                    this.recalcularPreciosTodosLosInsumos(nuevoPrecioId);
                    // Cambio la lista, asi que cambian las reglas y el descuento minimo.
                    this.reglas.consultarContexto(clienteId, nuevoPrecioId);
                },
                onCancel: () => {
                    this.formRef.current.setFieldsValue({ contado: anterior });
                },
            });
            return;
        }

        if (insumos?.length > 0) { this.contadoAnterior = value; return; }
        if (this.state.pedidosSeleccionados?.length > 0) { this.contadoAnterior = value; return; }
        if (!clienteId) { this.contadoAnterior = value; return; }
        if (esCambioReal) {
            this.formRef.current.setFieldsValue({
                precioId: nuevoPrecioId,
            });
            this.precioIdAnterior = nuevoPrecioId;
        }
        this.contadoAnterior = value;
    }

    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ clienteId: undefined });
        }
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    }
    cerrarMandarCorreoEmbarque() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current.resetFields();
        this.atras();
    }
    
    abrirLeyenda = (value, leyenda, insumoId) => {
        const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())

        const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
        const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);
        const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno} ${clienteActual.apellidoMaterno}`) : 'Cliente Desconocido';


        this.setState({
            modalLeyenda: true,
            modalLeyendaIndex: value,
            modalLeyendaLeyenda: leyenda,
            modalLeyendaLeyendasPasadas: insumo?.leyendasPasadas,
            clienteIdActual: clienteIdActual, 
            nombreClienteActual: nombreClienteActual
        })
    }
    cerrarLeyenda = (value) =>{
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalLeyendaIndex].leyenda = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalLeyenda: false,
            modalLeyendaIndex: null,
            modalLeyendaLeyenda: null,
            modalLeyendaLeyendasPasadas: null,
            clienteIdActual: null,
            nombreClienteActual: null
        })
    }

    abrirObservaciones = (value, observaciones, insumoId, observacionesXml) =>{
        const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())
        const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
        const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);
        const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno} ${clienteActual.apellidoMaterno}`) : 'Cliente Desconocido';

        this.setState({
            modalObservaciones: true,
            modalObservacionesIndex: value,
            modalObservacionesObservaciones: observaciones,
            modalObservacionesObservacionesXml: observacionesXml,
            modalObservacionesObservacionesPasadas: insumo?.observacionesPasadas, 
            clienteIdActual: clienteIdActual, 
            nombreClienteActual: nombreClienteActual
        })
    }
    cerrarObservaciones(value, observacionesXml) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalObservacionesIndex].observaciones = value
        insumos[this.state.modalObservacionesIndex].observacionesXml = observacionesXml
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalObservaciones: false,
            modalObservacionesIndex: null,
            modalObservacionesObservaciones: null,
            modalObservacionesObservacionesXml: null,
            modalObservacionesObservacionesPasadas: null,
            clienteIdActual: null,
            nombreClienteActual: null
        })
    }

    abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
        const clienteId = this.formRef.current.getFieldValue('clienteId')
        if (proyectoId) {
            this.setState({
                modalElegirLotes: true,
                modalElegirLotesIndex: value,
                modalElegirLotesLotes: lotes || [],
                modalElegirLotesInsumoId: insumoId,
                modalElegirLotesProyectoId: proyectoId,
                modalElegirLotesClienteId: clienteId,
                modalElegirLotesCantidad: cantidad
            })
        } else {
            message.warning('Elegir un proyecto para elegir lotes')
        }
    }
    cerrarElegirLotes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirLotesIndex].lotes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirLotes: false,
            modalElegirLotesIndex: null,
            modalElegirLotesLotes: null,
            modalElegirLotesInsumoId: null,
            modalElegirLotesProyectoId: null,
            modalElegirLotesClienteId: null,
            modalElegirLotesCantidad: null
        })
    }

    abrirElegirAgrupaciones(value, agrupaciones, insumoId, proyectoId) {
        const clienteId = this.formRef.current.getFieldValue('clienteId')
        if (proyectoId) {
            this.setState({
                modalElegirAgrupaciones: true,
                modalElegirAgrupacionesIndex: value,
                modalElegirAgrupacionesAgrupaciones: agrupaciones || [],
                modalElegirAgrupacionesInsumoId: insumoId,
                modalElegirAgrupacionesProyectoId: proyectoId,
                modalElegirAgrupacionesClienteId: clienteId
            })
        } else {
            message.warning('Elegir un proyecto para elegir agrupaciones')
        }
    }
    cerrarElegirAgrupaciones(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        if (insumos[this.state.modalElegirAgrupacionesIndex]?.agrupaciones) {
            insumos[this.state.modalElegirAgrupacionesIndex].agrupaciones = value
        }
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirAgrupaciones: false,
            modalElegirAgrupacionesIndex: null,
            modalElegirAgrupacionesAgrupaciones: null,
            modalElegirAgrupacionesInsumoId: null,
            modalElegirAgrupacionesProyectoId: null,
            modalElegirAgrupacionesClienteId: null
        })
    }

    async abrirVerInsumo(key) {
        if (!this.props.permisoModificarPrecioUnitarioPedidos) return;
        const arrayValue = await this.formRef.current.getFieldValue("insumos");
        const precioId = await this.formRef.current.getFieldValue("precioId");
        const tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;

        if (insumo.verInsumoVenta) {
            this.setState({
                modalVerInsumo: true,
                modalVerInsumoId: insumo._id,
                modalVerInsumoPrecioId: precioId,
                modalVerInsumoIndex: key,
                modalVerInsumoTipoDeCambio: tipoDeCambio
            })
        }
    }

    cerrarVerInsumo = async (precio) => {

        if (precio && precio > 0) {
            const insumos = await this.formRef.current.getFieldValue('insumos');
            insumos[this.state.modalVerInsumoIndex].precioUnitario = precio;
            await this.formRef.current.setFieldsValue({ insumos });
            this.onChangePrecioCantidadDescuento(undefined, this.state.modalVerInsumoIndex);
        }

        this.setState({
            modalVerInsumo: false,
            modalVerInsumoId: null,
            modalVerInsumoPrecioId: null,
            modalVerInsumoIndex: 0,
            modalVerInsumoTipoDeCambio: 1
        });
    }

    abrirElegirPedido = (arrayKey, insumoId, cantidad, pedidosOrigen) => {
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        if (!clienteId) {
            return message.warning("Selecciona un cliente primero");
        }
        if (!insumoId) {
            return message.warning("Selecciona un insumo primero");
        }
        if (!cantidad || cantidad <= 0) {
            return message.warning("Captura la cantidad del insumo primero");
        }
        this.setState({
            modalElegirPedido: true,
            modalElegirPedidoIndex: arrayKey,
            modalElegirPedidoInsumoId: insumoId,
            modalElegirPedidoCantidad: cantidad,
            modalElegirPedidoPedidosOrigen: pedidosOrigen || [],
        });
    }

    cerrarElegirPedido = (pedidosOrigen, leyenda) => {
        if (pedidosOrigen) {
            const insumos = this.formRef.current.getFieldValue("insumos");
            if (insumos && insumos[this.state.modalElegirPedidoIndex]) {
                insumos[this.state.modalElegirPedidoIndex].pedidosOrigen = pedidosOrigen;
                if (leyenda !== undefined) {
                    insumos[this.state.modalElegirPedidoIndex].leyenda = leyenda;
                }
                this.formRef.current.setFieldsValue({ insumos });
            }
        }
        this.setState({
            modalElegirPedido: false,
            modalElegirPedidoIndex: null,
            modalElegirPedidoInsumoId: null,
            modalElegirPedidoCantidad: 0,
            modalElegirPedidoPedidosOrigen: [],
        });
    }

    async onChangeEstado(value, inicial) {
        if (!inicial) {
            this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    municipioId: undefined,
                    coloniaId: undefined
                }
            });
        }
        await axios
            .post(
                "municipios/selectMunicipios",
                { estadoId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoMunicipios = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasMunicipios: res.data,
                        objetoMunicipios: objetoMunicipios,
                    });
                }
            });
    }

    async onChangeMunicipio(value, inicial) {
        await axios
            .post(
                "colonias/selectColonias",
                { municipioId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoColonias = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.cp + " - " + value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasColonias: res.data,
                        objetoColonias: objetoColonias,
                    });
                }
            });
    }


    async onSearchColonia(value) {
        if (value.toString().length === 5) {
            await axios
                .post(
                    "colonias/buscarCP",
                    { cp: value },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.status === 404) {
                        message.info("No se encontro el codigo postal");
                    } else {
                        this.formRef.current.setFieldsValue({
                            direccionEntrega: {
                                paisId: res.data.paisId,
                                estadoId: res.data.estadoId,
                                municipioId: res.data.municipioId
                            }
                        });
                        this.onChangeEstado(res.data.estadoId, true);
                        this.onChangeMunicipio(res.data.municipioId, true);
                    }
                });
        }
    }
    async onSelectColoniaId(coloniaId, fieldKey) {
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
        if (!direccionEntrega?.colonia) {
            const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
            await this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    colonia: nombreColonia
                }
            })
        }
    }

    async handleChangeDireccionEntrega(value) {
        this.setState({ loadingEntrega: true })
        if (value) {
            const direccion = this.state.direccionesCliente.find((direccion) => direccion._id.toString() === value.toString())
            if (direccion) {
                if (direccion.estadoId) {
                    await this.onChangeEstado(direccion.estadoId, true);
                }
                if (direccion.municipioId) {
                    await this.onChangeMunicipio(direccion.municipioId, true);
                }
                if (direccion?.plantaEntregaId) {
                    await this.onSearchPlantaEntrega(direccion?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
                }
                this.formRef.current.setFieldsValue({
                    direccionEntrega: {
                        paisId: direccion.paisId,
                        estadoId: direccion.estadoId,
                        municipioId: direccion.municipioId,
                        coloniaId: direccion.coloniaId,
                        colonia: direccion.colonia,
                        calle: direccion.calle,
                        numeroCalle: direccion.numeroCalle,
                        numeroInterior: direccion.numeroInterior,
                        descripcion: direccion.descripcion,
                        telefono: direccion.telefono,
                        correo: direccion.correo,
                        observaciones: direccion.observaciones,
                        plantaEntregaId: direccion?.plantaEntregaId,
                        referencia: direccion?.referencia,
                        clienteNombre: direccion?.clienteNombre,
                        clienteRfc: direccion?.clienteRfc
                    }
                })
            }
        }
        this.setState({ loadingEntrega: false })
    }

    consultarInformacionEntrega() {
        if (this.state.todasPaises.length > 0) return
        this.setState({ loadingEntrega: true })
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");

        axios.post("direcciones/selectInformacionDomicilio", { direccion: direccionEntrega }, {
            headers: this.props.headersToken
        })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loadingEntrega: false,
                        todasPaises: res.data.paises,
                        todasEstado: res.data.estados,
                        todasMunicipios: res.data.municipios,
                        todasColonias: res.data.colonias,
                        objetoMunicipios: res.data.municipios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoColonias: res.data.colonias.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.cp + " - " + value.nombre}
                                </Option>
                            );
                        }),
                        objetoPaises: res.data.paises.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                        objetoEstados: res.data.estados.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                    })
                } else {
                    message.info("No se encontró información para entrega")
                    this.setState({
                        loadingEntrega: false
                    })
                }
            })
    }

    onChangeMoneda(value) {
        if (value && value !== '60c7e4396465ad440c41c15a') {
            axios
                .post(
                    "tipoDeCambio/obtenerTipoDeCambio",
                    {
                        monedaId: value,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        if (res.data.monedaString && res.data.dia) {
                            message.success("Se ha obtenido el tipo de cambio" + (res.data.monedaString ? (" " + res.data.monedaString) : '') + (res.data.dia ? (' del día ' + res.data.dia) : ''));
                        }
                        this.formRef.current.setFieldsValue({
                            tipoDeCambio: res.data.tipoDeCambio,
                        });
                    }
                });
        }
    }
    onSearchPlantaEntrega = async (value, fieldKey, opts = {}) => {
        const { byId = false, setSelected = false } = opts;
        if (byId) {
            await axios
                .post(
                    "plantaDeEntrega/selectPlantaEntregaPorId",
                    { id: value },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    const p = res?.data?.dato || null;
                    if (!p || !p._id) {
                        this.setState(prev => ({
                            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                        }));
                        message.warning("No se encontró la planta por ID.");
                        return;
                    }

                    const option = (
                        <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
                            {p.label}
                        </Option>
                    );

                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [option] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));

                    if (setSelected && (this.props.form?.setFieldsValue || this.form?.setFieldsValue)) {
                        const form = this.props.form || this.form;
                        form.setFields([
                            { name: ['"direccionEntrega"', fieldKey, 'plantaEntregaId'], value: p._id }
                        ]);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    message.error("Error al buscar planta por ID");
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                });

            return;
        }
        this.setState(prev => ({
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: true }
        }));
        await axios
            .post(
                "plantaDeEntrega/selectPlantasDeEntrega",
                {
                    query: value || ""
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res?.data.success !== 2) {
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                    return;
                }
                const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
                const options = items.map(it => (
                    <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
                        {it.label}
                    </Option>
                ));

                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: options },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            })
            .catch((err) => {
                console.error(err);
                message.error("Error al buscar plantas de entrega");
                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            });
    }
      async consultarDatosEquipoMedico() {
        this.setState({ loading: true })
        await axios
            .post(
            "ventas/selectDatosParaEquipoMedico",
            { empresaId: this.props.empresaId },
            {
                headers: this.props.headersToken,
            }
            )
            .then((res) => {
            if (res.data.success === 2) {
                this.setState({
                loading: false,
                todasDoctores: res.data.doctores,
                todasPacientes: res.data.pacientes,
                todasCirugias: res.data.cirugias,
                objetoDoctores: res.data.doctores.map((value) => {
                    return (
                    <Option value={value._id} key={value._id}>
                        {value.codigo + ' - ' + value.nombre}
                    </Option>
                    );
                }),
                objetoPacientes: res.data.pacientes.map((value) => {
                    return (
                    <Option value={value._id} key={value._id}>
                        {value.codigo + ' - ' + value.nombre}
                    </Option>
                    );
                }),
                objetoCirugias: res.data.cirugias.map((value) => {
                    return (
                    <Option value={value._id} key={value._id}>
                        {value.codigo + ' - ' + value.nombre}
                    </Option>
                    );
                }),
                });
            } else {
                message.error('No se encontraron datos de equipo medico')
            }
        });
    }
    
    abrirAgregarCirugia(value) {
        this.setState({
        modalAgregarCirugia: true,
        })
    }

    cerrarAgregarCirugia(value) {
        this.setState({
        modalAgregarCirugia: false,
        })
        this.consultarDatosEquipoMedico()
    }

    abrirAgregarDoctor(value) {
        this.setState({
        modalAgregarDoctor: true,
        })
    }

    cerrarAgregarDoctor(value) {
        this.setState({
        modalAgregarDoctor: false,
        })
        this.consultarDatosEquipoMedico()
    }

    abrirAgregarPaciente(value) {
        this.setState({
        modalAgregarPaciente: true,
        })
    }

    cerrarAgregarPaciente(value) {
        this.setState({
        modalAgregarPaciente: false,
        })
        this.consultarDatosEquipoMedico()
    }

    moverInsumo = (fromIndex, toIndex, moveAntd) => {
        moveAntd(fromIndex, toIndex);

        this.setState(prev => {
            const nuevosTipos = { ...prev.tiposDescuento };
            const temp = nuevosTipos[fromIndex];
            nuevosTipos[fromIndex] = nuevosTipos[toIndex];
            nuevosTipos[toIndex] = temp;
            return { tiposDescuento: nuevosTipos };
        });

        this.setState({});
    };

    handleDireccionEntregaChange = (direccionValues) => {
        if (direccionValues) {
            this.formRef.current?.setFieldsValue({ direccionEntrega: direccionValues });
        }
        this.forceUpdate();
    };

    getInsumosColumns() {
        // Escuela: Insumo y Proyecto ceden el ancho de Desc. Cliente para que
        // Subtotal / Impuesto / Total no se encoja.
        return [
            { title: "#", width: "3%" },
            { title: "Insumo", width: this.props.escuela ? "14%" : "18%" },
            { title: "Unidad", width: "6%" },
            { title: "Proyecto", width: this.props.escuela ? "7%" : "9%" },
            { title: "PU", width: "9%" },
            { title: "Precio Neto", width: "9%" },
            { title: "Inventario", width: "7%" },
            {
                title: (
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            const items = getFieldValue("insumos") || [];
                            const totalCantidad = items.reduce(
                                (suma, it) => suma + (Number(it?.cantidad) || 0),
                                0
                            );
                            return (
                                <>
                                    <div>Cant.</div>
                                    <div style={{ fontWeight: 400, fontSize: '11px', color: '#868585' }}>
                                        Total: {totalCantidad}
                                    </div>
                                </>
                            );
                        }}
                    </FormItem>
                ),
                width: "7%",
            },
            ...(this.props.escuela
                ? [{ title: (<>Desc. Cliente{' '}<Tooltip title="Descuento predeterminado del cliente. El Desc. Adic. se aplica en cascada sobre lo que queda." mouseEnterDelay={0.5}><span style={{ cursor: 'help', color: '#1890ff', fontSize: '12px' }}>?</span></Tooltip></>), width: "6%" }]
                : []),
            { title: (<>{this.props.escuela ? "Desc. Adic." : "Desc."}{' '}<Tooltip title="Doble click en la celda para cambiar entre descuento % y $" mouseEnterDelay={0.5}><span style={{ cursor: 'help', color: '#1890ff', fontSize: '12px' }}>?</span></Tooltip></>), width: "8%" },
            { title: "Subtotal / Impuesto / Total", width: "10%" },
            { title: (<Tooltip title={this.state.modoReordenar ? "Terminar de reordenar" : "Reordenar insumos"}><ButtonItem key="btn-reordenar" type={this.state.modoReordenar ? "primary" : "default"} onClick={() => this.setState({ modoReordenar: !this.state.modoReordenar })} icon={<SwapOutlined rotate={90} />} size="small" morado={this.state.modoReordenar} blanco={!this.state.modoReordenar} lesstime /></Tooltip>), width: "12%" }
        ];
    }

    renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove, move, formInstance }) {
        const insumosValues = this.formRef.current?.getFieldValue("insumos") || [];
        const totalFields = insumosValues.length;
        const esPrimero = arrayKey === 0;
        const esUltimo = arrayKey === totalFields - 1;
        const insumoFilaActual = insumosValues[arrayKey];
        let insumoPrecargado = null;
        if (insumoFilaActual && insumoFilaActual.insumoId && this.state.todasInsumos) {
            insumoPrecargado = this.state.todasInsumos.find(
                i => i._id.toString() === (insumoFilaActual.insumoId?._id || insumoFilaActual.insumoId).toString()
            );
        }
        return (
            <React.Fragment key={key}>
                <tr className="fila-insumo">
                    <td className="td-border">
                        <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                            {arrayKey + 1}
                        </div>
                    </td>
                    <td className="td-border" style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        <FormItem {...restField} name={[name, "insumoId"]} required noStyle>
                            <SelectInsumosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                sinBorde
                                focusTdIndex={3}
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Insumo"
                                onChange={(value, insumo) => this.onChangeInsumoProyecto(value, arrayKey, 'insumo', false, insumo)}
                                insumoPreCargado={insumoPrecargado}
                            />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                                const insumoSeleccionado = this.state.todasInsumos?.find(
                                    (insumo) => insumo._id.toString() === insumoId?.toString()
                                );
                                return <div style={{ fontSize: '14px', textAlign: 'center' }}>{insumoSeleccionado?.unidad || '-'}</div>;
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId} noStyle>
                            {({ getFieldValue }) => {
                                const proyectoId = getFieldValue("proyectoId");
                                return (
                                    <FormItem {...restField} name={[name, "proyectoId"]} required noStyle initialValue={proyectoId}>
                                        <SelectItem sinBorde width="100%" placeholder="Proyecto" onChange={(value) => this.onChangeInsumoProyecto(value, arrayKey, 'proyecto')}>
                                            {this.state.objetoProyectos}
                                        </SelectItem>
                                    </FormItem>
                                );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border" onContextMenu={(e) => { e.preventDefault(); this.abrirVerInsumo(arrayKey); }}>
                        {/* El div flex va FUERA del FormItem: FormItem con `name` inyecta value/onChange
                            al unico hijo directo, asi que envolver el input en un div deja al input sin
                            valor al abrir y sin avisarle al form store al teclear. Mismo acomodo que el
                            descuento de abajo y que AgregarVenta. */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ flex: 1 }}>
                                <FormItem {...restField} name={[name, "precioUnitario"]} noStyle required numberCero>
                                    <InputNumberItem sinBorde onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)} placeholder="Precio Unitario" dinero disabled={this.estaBloqueado("precioUnitario", arrayKey)} />
                                </FormItem>
                            </div>
                            {/* Aviso en vivo de las reglas de la lista de precios. No bloquea
                                la captura: el vendedor tiene que poder teclear el valor para
                                poder pedir autorizacion sobre el. */}
                            {this.state.fueraDeRango[arrayKey]?.campo === "precioUnitario" ? (
                                <Tooltip title={this.state.fueraDeRango[arrayKey].motivo}>
                                    <WarningOutlined style={{ color: "#faad14", marginLeft: 4 }} />
                                </Tooltip>
                            ) : null}
                            <BotonAutorizacion
                                visible={this.props.autorizacionesRapidas && this.tieneInsumoSeleccionado(arrayKey) && this.estaBloqueado("precioUnitario", arrayKey)}
                                onClick={() => this.abrirModalAutorizacion("precioUnitario", arrayKey)}
                            />
                        </div>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "precioUnitarioConImpuestos"]} noStyle required>
                            <InputNumberItem sinBorde disabled={this.estaBloqueado("precioUnitario", arrayKey)} placeholder="Precio Unitario con Impuestos" dinero onChange={(value) => { this.onChangePrecioConImpuestos(value, arrayKey); }} />
                        </FormItem>
                    </td>
                    <td
                        className="td-border"
                        onDoubleClick={() => {
                            const insumos = this.formRef.current.getFieldValue('insumos');
                            const insumoId = insumos[arrayKey]?.insumoId;
                            const insumoObj = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
                            if (insumoId) this.abrirDisponibilidad(insumoId, insumoObj?.nombre || insumoObj?.descripcion || '', insumos[arrayKey]?.proyectoId);
                        }}
                        onContextMenu={(e) => {
                            e.preventDefault();
                            const insumos = this.formRef.current.getFieldValue('insumos');
                            const insumoId = insumos[arrayKey]?.insumoId;
                            const insumoObj = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
                            this.abrirHistorialCliente(insumoId, insumoObj?.nombre || insumoObj?.descripcion || '', arrayKey);
                        }}
                        title="Doble clic: disponibilidad · Clic derecho: historial con este cliente"
                        style={{ cursor: 'pointer' }}
                    >
                        <div style={{ pointerEvents: 'none' }}>
                            <FormItem {...restField} name={[name, "cantidadProyecto"]} required noStyle>
                                <InputNumberItem sinBorde disabled placeholder="Inventario" />
                            </FormItem>
                        </div>
                    </td>
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos[arrayKey]?.cantidadProyecto !== curr.insumos[arrayKey]?.cantidadProyecto}>
                               {({ getFieldValue }) => {
                                const insumos = getFieldValue("insumos");
                                const cantidadProyecto =
                                    insumos[arrayKey].cantidadProyecto;
                                let max = 0;
                                if (
                                    cantidadProyecto === "No inventariable"
                                ) {
                                    max = Infinity;
                                } else {
                                    max = cantidadProyecto;
                                }
                                return (
                                    <FormItem
                                        {...restField}
                                        name={[name, "cantidad"]}
                                        number
                                        noStyle
                                        type="number"
                                        required
                                    >
                                        <InputNumberItem
                                            sinBorde
                                            placeholder={
                                                max && max !== Infinity
                                                    ? "Max: " + max
                                                    : "Cantidad"
                                            }
                                            onChange={(value) =>
                                                this.onChangePrecioCantidadDescuento(
                                                    value,
                                                    arrayKey
                                                )
                                            }
                                        />
                                    </FormItem>
                                );
                            }}
                        </FormItem>
                    </td>
                    {/* Columna: Desc. Cliente (complemento Escuela) */}
                    {this.props.escuela && (
                        <td className="td-border">
                            <FormItem
                                {...restField}
                                key={`desc-base-${arrayKey}`}
                                name={[name, "descuentoBase"]}
                                numberCero
                                noStyle
                                initialValue={0}
                            >
                                <InputNumberItem
                                    disabled={this.estaBloqueado("descuento", arrayKey)}
                                    sinBorde
                                    placeholder="Desc. %"
                                    porcentaje
                                    max={100}
                                    onChange={() => this.onChangeDescuentoEscuela(arrayKey)}
                                />
                            </FormItem>
                        </td>
                    )}
                    <td className="td-border">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ flex: 1 }}>
                        {this.state.tiposDescuento[arrayKey] === 'cantidad' ? (
                            <FormItem
                                {...restField}
                                key={`desc-cantidad-${arrayKey}`}
                                name={[name, "descuentoCantidad"]}
                                numberCero
                                noStyle
                                initialValue={0}
                            >
                                <InputNumberItem
                                    disabled={this.estaBloqueado("descuento", arrayKey)}
                                    sinBorde
                                    placeholder="Desc. $"
                                    dinero
                                    onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                                    onChange={(value) =>
                                        this.onChangePrecioCantidadDescuento(value, arrayKey)
                                    }
                                />
                            </FormItem>
                        ) : (
                            <FormItem
                                {...restField}
                                key={`desc-porcentaje-${arrayKey}`}
                                name={[name, this.props.escuela ? "descuentoAdicional" : "descuento"]}
                                required
                                numberCero
                                noStyle
                                initialValue={0}
                            >
                                <InputNumberItem
                                    disabled={this.estaBloqueado("descuento", arrayKey)}
                                    sinBorde
                                    placeholder="Desc. %"
                                    porcentaje
                                    max={100}
                                    onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                                    onChange={(value) =>
                                        this.props.escuela
                                            ? this.onChangeDescuentoEscuela(arrayKey)
                                            : this.onChangePrecioCantidadDescuento(value, arrayKey)
                                    }
                                />
                            </FormItem>
                        )}
                            </div>
                            {this.state.fueraDeRango[arrayKey]?.campo === "descuento" ? (
                                <Tooltip title={this.state.fueraDeRango[arrayKey].motivo}>
                                    <WarningOutlined style={{ color: "#faad14", marginLeft: 4 }} />
                                </Tooltip>
                            ) : null}
                            <BotonAutorizacion
                                visible={this.props.autorizacionesRapidas && this.tieneInsumoSeleccionado(arrayKey) && this.estaBloqueado("descuento", arrayKey)}
                                onClick={() => this.abrirModalAutorizacion("descuento", arrayKey)}
                            />
                        </div>
                    </td>
                     {/* Columna: Subtotal / Impuesto / Total */}
                    <td className="td-border">
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                        const subtotal = getFieldValue(['insumos', arrayKey, 'subtotal']) || 0;
                        const impuestos = getFieldValue(['insumos', arrayKey, 'impuestos']) || 0;
                        const total = getFieldValue(['insumos', arrayKey, 'total']) || 0;
        
                        const formatNumber = (num) => {
                            return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        };
        
                        return (
                            <div className="celda-totales" style={{ fontSize: '13px' }}>
                            <div>${formatNumber(subtotal)}</div>
                            <div>${formatNumber(impuestos)}</div>
                            <div className="total-bold">Total: ${formatNumber(total)}</div>
                            </div>
                        );
                        }}
                    </FormItem>
        
                    {/* Campos hidden para mantener los valores en el form */}
                    <FormItem {...restField} name={[name, "subtotal"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    <FormItem {...restField} name={[name, "impuestos"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    <FormItem {...restField} name={[name, "total"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    </td>
                    <td className="td-border-sin-right">
                        <Row className="acciones-container">
                            <Col span={24}>
                                <Space
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                    size={0}
                                    className="acciones-container"
                                >
                                    <Space size={0}>
                                        {this.state.modoReordenar ? (
                                            <>
                                                <ButtonItem
                                                    type="primary" size="small"
                                                    disabled={esPrimero}
                                                    cyan
                                                    onClick={() => this.moverInsumo(arrayKey, arrayKey - 1, move)}
                                                    icon={<ArrowUpOutlined />}
                                                    lessTime
                                                />
                                                <ButtonItem
                                                    type="primary" size="small"
                                                    disabled={esUltimo}
                                                    naranja
                                                    onClick={() => this.moverInsumo(arrayKey, arrayKey + 1, move)}
                                                    icon={<ArrowDownOutlined />}
                                                    lessTime
                                                />
                                            </>
                                        ) : (
                                            <FormItem noStyle shouldUpdate>
                                                {({ getFieldValue }) => {
                                                    let arrayValue = getFieldValue("insumos");
                                                    let buttons = [];
                                                    if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                                        const insumo = this.state.todasInsumos.find(
                                                            (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                                        );
                                                        const mostrarMarbetes = insumo?.marbetes;
                                                        const mostrarLotes = insumo?.lotesCaducidades;
                                                        const mostrarAgrupaciones = insumo?.agrupaciones;
                                                        const mostrarLeyenda = insumo?.leyendaVenta;
                                                        const mostrarObservaciones = insumo?.observacionesVenta;
                                                        const insumoId = insumo?._id;
                                                        const proyectoId = arrayValue[arrayKey]?.proyectoId;

                                                        buttons.push(
                                                            <Tooltip key="det-tooltip" title="Ver detalle del insumo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                                <ButtonItem type="primary" size="small" cyan icon={<EyeOutlined />} onClick={() => this.abrirDetalleInsumo(arrayValue[arrayKey].insumoId, insumo?.nombre || insumo?.descripcion || '')} />
                                                            </Tooltip>
                                                        );

                                                        if (mostrarLeyenda) {
                                                            buttons.push(
                                                                <Tooltip key="ley-tooltip" title="Agregar Leyenda" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                                    <ButtonItem type="primary" size="small" icon={<FileTextOutlined />} lima2 verde={arrayValue[arrayKey].leyenda} onClick={() => this.abrirLeyenda(arrayKey, arrayValue[arrayKey].leyenda, arrayValue[arrayKey].insumoId)} />
                                                                </Tooltip>
                                                            );
                                                        }
                                                        if (mostrarMarbetes) {
                                                            buttons.push(
                                                                <Tooltip key="mar-tooltip" title="Marbetes" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                                    <ButtonItem type="primary" size="small" cyan2 icon={<TagsOutlined />} onClick={() => this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId, proyectoId)} />
                                                                </Tooltip>
                                                            );
                                                        }
                                                        if (mostrarAgrupaciones) {
                                                            buttons.push(
                                                                <Tooltip key="agr-tooltip" title="Agrupaciones" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                                    <ButtonItem type="primary" size="small" cyan2 icon={<AppstoreOutlined />} onClick={() => this.abrirElegirAgrupaciones(arrayKey, arrayValue[arrayKey].agrupaciones, insumoId, proyectoId)} />
                                                                </Tooltip>
                                                            );
                                                        } else if (mostrarLotes) {
                                                            buttons.push(
                                                                <Tooltip key="lot-tooltip" title={this.props.taxidermia ? "Animales" : "Lotes"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                                    <ButtonItem type="primary" size="small" amarillo2 icon={<DatabaseOutlined />} onClick={() => this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].cantidad)} />
                                                                </Tooltip>
                                                            );
                                                        }
                                                        if (textoDescripcionLarga(insumo)) {
                                                            buttons.push(
                                                                <BotonDescripcionLarga key="desc-larga" renglon={arrayValue[arrayKey]} insumoOriginal={insumo} onToggle={(valor) => {
                                                                    const insumosActuales = this.formRef.current.getFieldValue('insumos');
                                                                    insumosActuales[arrayKey].imprimirDescripcionLarga = valor;
                                                                    this.formRef.current.setFieldsValue({ insumos: insumosActuales });
                                                                    this.forceUpdate();
                                                                }} />
                                                            );
                                                        }
                                                        if (mostrarObservaciones) {
                                                            buttons.push(
                                                                <Tooltip key="obs-tooltip" title="Agregar Observaciones" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                                    <ButtonItem type="primary" size="small" cyan2 icon={<CommentOutlined />} verde={arrayValue[arrayKey].observaciones} onClick={() => this.abrirObservaciones(arrayKey, arrayValue[arrayKey].observaciones, arrayValue[arrayKey].insumoId, arrayValue[arrayKey].observacionesXml)} />
                                                                </Tooltip>
                                                            );
                                                        }
                                                        if (!this.state.pedidosSeleccionados || this.state.pedidosSeleccionados.length === 0) {
                                                            const pedidosOrigen = arrayValue[arrayKey].pedidosOrigen || [];
                                                            const tienePedidos = pedidosOrigen.length > 0;
                                                            buttons.push(
                                                                <Tooltip key="ped-tooltip" title="Elegir Pedido" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                                    <ButtonItem type="primary" size="small" morado icon={<ProfileOutlined />} verde={tienePedidos} onClick={() => this.abrirElegirPedido(arrayKey, insumoId, arrayValue[arrayKey].cantidad, pedidosOrigen)} />
                                                                </Tooltip>
                                                            );
                                                        }
                                                    }
                                                    return buttons;
                                                }}
                                            </FormItem>
                                        )}
                                    </Space>
                                    <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                        <ButtonItem rojo2 icon={<DeleteOutlined />} onClick={() => remove(name)} size="small" lessTime />
                                    </Tooltip>
                                </Space>
                            </Col>
                        </Row>
                    </td>
                </tr>
                {(!this.state.pedidosSeleccionados || this.state.pedidosSeleccionados.length === 0) && (
                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && (prev.insumos[arrayKey]?.cantidad !== curr.insumos[arrayKey]?.cantidad || prev.insumos[arrayKey]?.pedidosOrigen !== curr.insumos[arrayKey]?.pedidosOrigen)}>
                        {({ getFieldValue }) => {
                            const arrayValue = getFieldValue("insumos");
                            const fila = arrayValue && arrayValue[arrayKey];
                            if (!fila || !fila.cantidad || fila.cantidad <= 0) return null;
                            const sumPedidos = (fila.pedidosOrigen || []).reduce((s, p) => s + (Number(p?.cantidad) || 0), 0);
                            if (sumPedidos === Number(fila.cantidad)) return null;
                            return (
                                <tr>
                                    <td colSpan={this.props.escuela ? 12 : 11} style={{ padding: 0 }}>
                                        <div style={{ height: 4, backgroundColor: '#ff4d4f' }} title={`Cantidad de pedidos asignada (${sumPedidos}) no coincide con la cantidad del insumo (${fila.cantidad})`} />
                                    </td>
                                </tr>
                            );
                        }}
                    </FormItem>
                )}
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
                    {({ getFieldValue }) => {
                        let arrayValue = getFieldValue("insumos");
                        if (arrayValue && arrayValue[arrayKey]?.leyenda) {
                            return (<tr className="fila-leyenda"><td colSpan={this.props.escuela ? 12 : 11} className="td-border"><div className="contenedor-leyenda"><div className="texto-leyenda"><b>Leyenda:</b> {arrayValue[arrayKey].leyenda}</div></div></td></tr>);
                        }
                    }}
                </FormItem>
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && (prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml)}>
                    {({ getFieldValue }) => {
                        let arrayValue = getFieldValue("insumos");
                        if (arrayValue && arrayValue[arrayKey]?.observaciones) {
                            return (<tr className="fila-observaciones"><td colSpan={this.props.escuela ? 12 : 11} className="td-border-sin-right"><div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', backgroundColor: arrayValue[arrayKey].observacionesXml ? '#dceeffff' : 'white' }}><div style={{ width: '100%', textAlign: 'left', paddingLeft: 25, color: "#005661" }}>{String(arrayValue[arrayKey].observaciones).split(/\r?\n/).map((line, i) => <span key={i}>{line}<br /></span>)}</div></div></td></tr>);
                        }
                    }}
                </FormItem>
            </React.Fragment>
        );
    }

    // Método para obtener configuración de checkboxes
    getCheckboxesConfig() {
        const checkboxes = [];

        if (this.props.quitarImpuestosOpcionalVentas) {
            checkboxes.push({
                label: "Quitar Impuestos",
                name: "quitarImpuestos",
                onChange: (e) => {
                    this.setState({ quitarImpuestos: e.target.checked }, () => {
                        const insumos = this.formRef.current.getFieldValue("insumos");
                        if (insumos?.length) this.recalcularInsumosEnBatch(insumos);
                    });
                }
            });
        }

        checkboxes.push({
            label: "Imprimir",
            name: "imprimirObservaciones",
        });

        checkboxes.push({
            label: "Des. Imprimir Banco",
            name: "deshabilitarBanco",
        });

        return checkboxes;
    }

    getObservacionesConfig() {
        return {
            observaciones: {
                label: "Observaciones",
                value: this.formRef.current?.getFieldValue("observaciones") || "",
                onSave: (newValue) => {
                    this.formRef.current?.setFieldsValue({ observaciones: newValue });
                    this.forceUpdate();
                }
            },
            observaciones2: {
                label: "Observaciones Internas",
                value: this.formRef.current?.getFieldValue("observaciones2") || "",
                tooltip: "Estas observaciones no se imprimirán.",
                onSave: (newValue) => {
                    this.formRef.current?.setFieldsValue({ observaciones2: newValue });
                    this.forceUpdate();
                }
            },
            checkboxes: this.getCheckboxesConfig(),
            totales: null,
        };
    }

    render() {
        const isMobile = window.innerWidth <= 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Agregar Embarque"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                />
                <div className="card-background" style={{ paddingTop: 0 }}>
                    <Spin spinning={this.state.loading} style={{ display: "block", margin: "0 0 0 auto" }}>
                        <Form ref={this.formRef} name="agregarEmbarque" layout
                            onFinish={(values) => this.setState({ modalConfirmacion: true, valuesForm: values })}
                            onFinishFailed={this.onFinishFailed}>
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos?.length !== curr.insumos?.length || prev.contado !== curr.contado || prev.factura !== curr.factura}>
                                {({ getFieldValue }) => {
                                    const insumos = getFieldValue("insumos");
                                    const disabled = insumos && insumos.length > 0;
                                    const contado = getFieldValue("contado");
                                    const factura = getFieldValue("factura");
                                    const showFormaDePago = factura === 1 || contado !== 1;
                                    return (
                                        <VentasForm
                                            totalPagar={this.state.totalPagar || 0}
                                            showDoctor={this.props.equipoMedico}
                                            showRegimenFiscal={false}
                                            showMoneda={true}
                                            showFormaDePago={showFormaDePago}
                                            datosGeneralesCol={{ xs: 24, sm: 24, md: 24, lg: 18, xl: 18 }}
                                            monedaCol={{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }}
                                            datosGeneralesContent={(
                                            <>
                                                <Row gutter={[16, 8]} align="middle">
                                                   <Col xs={24} sm={24} md={14} lg={14}>
                                                     <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
                                                        <FormItem
                                                            label="Cliente"
                                                            name="clienteId"
                                                            margin
                                                            required
                                                            labelCol={{ span: 6 }}
                                                            wrapperCol={{ span: 18}} 
                                                            style={{ flex: 1, marginBottom: 0 }}
                                                        >
                                                            <SelectClientesItem
                                                            empresaId={this.props.empresaId}
                                                            headersToken={this.props.headersToken}
                                                            sinBorde
                                                            autoFocus
                                                            dropdownMatchSelectWidth={600}
                                                            width="100%"
                                                            placeholder="Cliente"
                                                            onChange={(valueId, cliente) => this.onChangeCliente(valueId, cliente)}
                                                            />
                                                        </FormItem>

                                                        <ButtonItem
                                                            type="primary"
                                                            icon={<PlusOutlined />}
                                                            cyan
                                                            disabled={disabled}
                                                            onClick={this.abrirAgregarCliente}
                                                            style={{ marginBottom: 4 }}
                                                        />
                                                     </div>
                                                    </Col>
                                                    <Col xs={12} sm={8} md={10} lg={10}>
                                                        <FormItem
                                                        label="Fecha"
                                                        name="fechaEmbarque"
                                                        required
                                                        margin
                                                        initialValue={moment()}
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        >
                                                        <DatePickerItem placeholder="Fecha" allowClear={false} />
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                              <Row gutter={[16, 8]} align="middle">
                                                <Col xs={24} sm={24} md={14} lg={14}>
                                                    <FormItem label="Vendedor"
                                                    initialValue={this.props.usuarioId}
                                                    name="vendedorId" margin
                                                    required
                                                    labelCol={{ span: 6 }}
                                                    wrapperCol={{ span: 18 }}>
                                                        <SelectItem placeholder="Vendedor">{this.state.objetoUsuarios}</SelectItem>
                                                    </FormItem>
                                                </Col>

                                                <Col xs={12} sm={8} md={10} lg={10}>
                                                    <FormItem
                                                    required
                                                    initialValue={1}
                                                    name="contado"
                                                    label="Método"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 12 }}
                                                    margin
                                                    >
                                                    <SelectItem
                                                        width="100%"
                                                        onChange={this.onChangeContado.bind(this)}
                                                        disabled={!this.props.permisoVenderCreditoPedidos}
                                                    >
                                                        <Option value={1}>Contado - PUE</Option>
                                                        <Option value={2}>Crédito - PPD</Option>
                                                    </SelectItem>
                                                    </FormItem>
                                                </Col>                                                
                                                </Row>
                                                <Row gutter={[16, 8]} align="middle">
                                                    <Col xs={24} sm={12} md={14} lg={14}>
                                                        <FormItem
                                                            name="canalDeVentaId"
                                                            margin
                                                            label="Canal"
                                                            labelCol={{ span: 6}}
                                                            wrapperCol={{ span: 18 }}
                                                            >
                                                                <SelectItem placeholder="Canal de Venta" width="100%">
                                                                {this.state.objetoCanalesVenta}
                                                                </SelectItem>
                                                            </FormItem>
                                                    </Col>
                                                </Row>
                                               
                                            </>
                                            )}

                                            datosClienteContent={(
                                                <Row gutter={[16, 8]}>
                                                    <Col span={24}>
                                                    <FormItem name="ordenDeCompra" label="O Compra" pattern margin labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                        <InputItem placeholder="Orden de Compra" />
                                                    </FormItem>
                                                    </Col>
                                                    <Col span={24}>
                                                    <FormItem name="req" label="Req" pattern margin labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                        <InputItem placeholder="Requisición" />
                                                    </FormItem>
                                                    </Col>
                                                    <Col span={24}>
                                                    <FormItem pattern name="atencion" label="Atención a" margin tooltip="Indica a quién dirigir este documento." labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                        <InputItem placeholder="Atención a" />
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                            )}

                                            extrasContent={(
                                                <Row gutter={[16, 8]}>
                                                    <Col span={24}>
                                                        <FormItem
                                                            name="fechaEntregaEstimada"
                                                            label="F. Entrega Est."
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <DatePickerItem placeholder="Fecha de entrega estimada" />
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                            )}

                                            doctorContent={this.props.equipoMedico ? (
                                            <>
                                                <Row gutter={[16, 8]}>
            
                                                {/* DOCTOR */}
                                                <Col xs={24} sm={24} md={20} lg={20}>
                                                    <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                        gap: 4,
                                                        flexWrap: 'wrap'
                                                    }}
                                                    >
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <FormItem
                                                        name="doctorId"
                                                        label="Doctor:"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        margin
                                                        required={this.state.docObligatorio}
                                                        >
                                                        <SelectItem placeholder="Doctor">
                                                            {this.state.objetoDoctores}
                                                        </SelectItem>
                                                        </FormItem>
                                                    </div>
            
                                                    <ButtonItem
                                                        type="primary"
                                                        icon={<PlusOutlined />}
                                                        style={{ flexShrink: 0, height: 32 }}
                                                        disabled={disabled} 
                                                        onClick={this.abrirAgregarDoctor.bind(this)}
                                                    />
                                                    </div>
                                                </Col>
            
                                                {/* PACIENTE */}
                                                <Col xs={24} sm={24} md={20} lg={20}>
                                                    <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                        gap: 4,
                                                        flexWrap: 'wrap'
                                                    }}
                                                    >
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <FormItem
                                                        name="pacienteId"
                                                        label="Paciente:"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        margin
                                                        >
                                                        <SelectItem placeholder="Paciente">
                                                            {this.state.objetoPacientes}
                                                        </SelectItem>
                                                        </FormItem>
                                                    </div>
            
                                                    <ButtonItem
                                                        type="primary"
                                                        icon={<PlusOutlined />}
                                                        style={{ flexShrink: 0, height: 32 }}
                                                        disabled={disabled} 
                                                        onClick={this.abrirAgregarPaciente.bind(this)}
                                                    />
                                                    </div>
                                                </Col>
            
                                                {/* CIRUGÍA */}
                                                <Col xs={24} sm={24} md={20} lg={20}>
                                                    <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                        gap: 4,
                                                        flexWrap: 'wrap'
                                                    }}
                                                    >
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <FormItem
                                                        name="cirugiaId"
                                                        label="Cirugía:"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        margin
                                                        >
                                                        <SelectItem placeholder="Cirugia">
                                                            {this.state.objetoCirugias}
                                                        </SelectItem>
                                                        </FormItem>
                                                    </div>
            
                                                    <ButtonItem
                                                        type="primary"
                                                        icon={<PlusOutlined />}
                                                        style={{ flexShrink: 0, height: 32 }}
                                                        onClick={this.abrirAgregarCirugia.bind(this)}
                                                        disabled={disabled}
                                                    />
                                                    </div>
                                                </Col>
            
                                                </Row>
                                            </>
                                            ) : null}

                                            monedaContent={(
                                                <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.insumos?.length !== curr.insumos?.length}>
                                                    {({ getFieldValue }) => {
                                                        const monedaId = getFieldValue('monedaId');
                                                        return (
                                                            <>
                                                                <FormItem
                                                                    required
                                                                    margin
                                                                    name="monedaId"
                                                                    labelCol={{ span: 8 }}
                                                                    wrapperCol={{ span: 24 }}
                                                                    initialValue='60c7e4396465ad440c41c15a'
                                                                >
                                                                    <SelectItem disabled={disabled} onChange={(value) => {
                                                                        if (value === '60c7e4396465ad440c41c15a') {
                                                                            this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                                                        } else {
                                                                            this.onChangeMoneda(value)
                                                                        }
                                                                    }} placeholder="Moneda">
                                                                        {this.state.objetoMonedas}
                                                                    </SelectItem>
                                                                </FormItem>
                                                                {/* Tipo de Cambio - Solo si NO es MXN */}
                                                                {monedaId !== '60c7e4396465ad440c41c15a' ? (
                                                                    <FormItem
                                                                        required
                                                                        number
                                                                        margin
                                                                        label="T. Cambio"
                                                                        name="tipoDeCambio"
                                                                        type="number"
                                                                        initialValue={1}
                                                                        labelCol={{ span: 8 }}
                                                                        wrapperCol={{ span: 16 }}
                                                                    >
                                                                        <InputNumberItem dinero placeholder="T. Cambio" />
                                                                    </FormItem>
                                                                ) : (
                                                                    <FormItem name="tipoDeCambio" initialValue={1} hidden>
                                                                        <InputNumberItem />
                                                                    </FormItem>
                                                                )}
                                                            </>
                                                        );
                                                    }}
                                                </FormItem>
                                            )}

                                            datosVentaContent={(
                                                <FormItem shouldUpdate noStyle>
                                                    {({ getFieldValue }) => {
                                                        const insumos = getFieldValue("insumos");
                                                        const disabledPago = insumos && insumos.length > 0;
                                                        return (
                                                            <>
                                                                <Col span={24}>
                                                                <FormItem label="Proyecto" name="proyectoId" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                                    <SelectItem placeholder="Proyecto" disabled={disabledPago}>
                                                                        {this.state.objetoProyectos}
                                                                    </SelectItem>
                                                                </FormItem>
                                                                </Col>
                                                                <Col span={24}>
                                                                    <div style={{ display: "flex", alignItems: "flex-end", gap: 6 }}>
                                                                        <FormItem name="precioId" label="Precio" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} style={{ flex: 1, marginBottom: 0, minWidth: 0 }}>
                                                                            <SelectItem
                                                                                placeholder="Precio"
                                                                                disabled={this.estaBloqueado("listaPrecios")}
                                                                                onChange={(value) => this.onChangePrecioId(value)}
                                                                            >
                                                                                {this.state.objetoPrecios}
                                                                            </SelectItem>
                                                                        </FormItem>
                                                                        <BotonAutorizacion
                                                                            visible={this.props.autorizacionesRapidas && this.estaBloqueado("listaPrecios")}
                                                                            onClick={() => this.abrirModalAutorizacion("listaPrecios")}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </>
                                                        );
                                                    }}
                                                </FormItem>
                                            )}

                                            formaDePagoContent={(
                                                <FormItem shouldUpdate noStyle>
                                                    {({ getFieldValue }) => {
                                                        const contado = getFieldValue("contado");
                                                        const factura = getFieldValue("factura");
                                                        const usoCFDI = factura === 1 ? (
                                                            <Col span={24}><FormItem name="usoDeCfdiId" label="Uso CFDI" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><SelectItem placeholder="Uso de CFDI">{this.state.objetoUsosDeCFDI}</SelectItem></FormItem></Col>
                                                        ) : null;
                                                        const diasCredito = contado !== 1 ? (
                                                            <Col span={24}><FormItem label="Días de crédito" name="diasCredito" numberCero margin required initialValue={0} labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><InputNumberItem placeholder="Días de Crédito" /></FormItem></Col>
                                                        ) : null;
                                                        if (!usoCFDI && !diasCredito) return null;
                                                        return (
                                                            <Row gutter={[6, 4]}>
                                                                {usoCFDI}
                                                                {diasCredito}
                                                            </Row>
                                                        );
                                                    }}
                                                </FormItem>
                                            )}

                                            tabs={[{
                                                key: "insumos", label: "Insumos", listName: "insumos", columns: this.getInsumosColumns(), renderRow: this.renderInsumoRow.bind(this),
                                                renderFooter: ({ add,fields }) => {
                                                    this.addInsumoRef = add;
                                                    return <FormItem noStyle shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId || prev.precioId !== curr.precioId || prev.clienteId !== curr.clienteId || prev.monedaId !== curr.monedaId || prev.tipoDeCambio !== curr.tipoDeCambio}>{({ getFieldValue }) => { const allFieldsValid = getFieldValue('proyectoId') && getFieldValue('precioId') && getFieldValue('clienteId') && getFieldValue('monedaId') && getFieldValue('tipoDeCambio'); 
                                                    return <div style={{ marginBottom: 6, marginTop: 6, display: 'flex', gap: 8, alignItems: 'center' }}>
                                                        <ButtonItem
                                                         style={{
                                                                    marginTop: 10,
                                                                    marginBottom: 10,
                                                                    justifySelf: fields.length > 0 ? "left" : null,
                                                                    width: fields.length > 0 ? "auto" : null,
                                                                    flex: 1,
                                                                }}
                                                        type="primary"
                                                        cyan
                                                        block
                                                        icon={<PlusOutlined />}
                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); allFieldsValid ? (this.state.cantidadDefault ? this.addInsumoRef?.({ cantidad: 1 }) : this.addInsumoRef?.()) : message.info("Agregue los datos de venta primero"); }}>
                                                            Agregar Insumo
                                                        </ButtonItem>
                                                        <ButtonItem
                                                            style={{ marginTop: 10, marginBottom: 10, flexShrink: 0 }}
                                                            icon={<SearchOutlined />}
                                                            hotkey="alt+b"
                                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); allFieldsValid ? this.abrirBusquedaAvanzada() : message.info("Agregue los datos de venta primero"); }}>
                                                            Búsqueda avanzada
                                                        </ButtonItem>
                                                        {!this.props.desactivarCargaExcelInsumosVentas && (
                                                        <ButtonItem
                                                            style={{ marginTop: 10, marginBottom: 10, flexShrink: 0 }}
                                                            icon={<FileExcelOutlined />}
                                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); allFieldsValid ? this.setState({ modalCargarExcelVisible: true }) : message.info("Agregue los datos de venta primero"); }}>
                                                            Cargar Excel
                                                        </ButtonItem>
                                                        )}
                                                        </div>;
                                                    }}
                                                  </FormItem>;
                                                }
                                            }, {
                                                key: "entrega", label: "Entrega", forceRender: true,
                                                customContent:
                                                <TabEntregaDireccion
                                                    key={`direccion-${this.state.direccionesCliente?.[0]?._id || 'no-cliente'}`}
                                                    loadingEntrega={this.state.loadingEntrega}
                                                    clienteDireccion={this.state.direccionesCliente?.[0]}
                                                    objetoDireccionesCliente={this.state.objetoDireccionesCliente} 
                                                    handleChangeDireccionEntrega={this.handleChangeDireccionEntrega.bind(this)}
                                                    onDireccionChange={this.handleDireccionEntregaChange}
                                                    formInstance={this.formRef.current} addendaMabe={this.state.addendaMabe}
                                                    loadingPlantasEntrega={this.state.loadingPlantasEntrega} 
                                                    objetoPlantasEntrega={this.state.objetoPlantasEntrega} 
                                                    onSearchPlantaEntrega={this.onSearchPlantaEntrega.bind(this)} 
                                                    objetoColonias={this.state.objetoColonias} 
                                                    onSearchColonia={this.onSearchColonia.bind(this)} 
                                                    onSelectColoniaId={this.onSelectColoniaId.bind(this)} 
                                                    objetoMunicipios={this.state.objetoMunicipios} 
                                                    onChangeMunicipio={this.onChangeMunicipio.bind(this)} 
                                                    objetoEstados={this.state.objetoEstados} 
                                                    onChangeEstado={this.onChangeEstado.bind(this)} 
                                                    objetoPaises={this.state.objetoPaises} />
                                            }].filter(Boolean)}
                                            defaultActiveKey="insumos"
                                            onTabChange={(key) => { if (key === "entrega") this.consultarInformacionEntrega(); return this.setState({ activeTabKey: key }); }}
                                            isMobile={isMobile}
                                            formInstance={this.formRef.current}
                                            observacionesConfig={(() => {
                                                    const config = this.getObservacionesConfig();
                                                    return { ...config, totales: (
                                                            <FormItem shouldUpdate noStyle>
                                                        {({ getFieldValue }) => {
                                                            let arrayInsumos = getFieldValue("insumos") || [];
                                                            let arrayRetenciones = [];
                                                            let cuentasCliente = 0;
                                                            let subtotal = 0;
                                                            let arrayImpuestos = [];
                                                            let total = 0;
                                                            arrayInsumos.map((value) => {
                                                                if (value) {
                                                                    if (
                                                                        value.subtotal &&
                                                                        value.total &&
                                                                        value.arrayImpuestos
                                                                    ) {
                                                                        subtotal += value.subtotal;
                                                                        total += value.subtotal;
                                                                        value.arrayImpuestos.map((valueImpuestos) => {
                                                                            let index = arrayImpuestos.findIndex(
                                                                                (valueImpuestosAnterios) =>
                                                                                    valueImpuestosAnterios.descripcionFactura ===
                                                                                    valueImpuestos.descripcionFactura
                                                                                    &&
                                                                                    valueImpuestosAnterios.tasaCuota ===
                                                                                    valueImpuestos.tasaCuota
                                                                                    &&
                                                                                    valueImpuestosAnterios.impuesto ===
                                                                                    valueImpuestos.impuesto
                                                                            );
                                                                            if (index !== -1) {
                                                                                let newItem = {
                                                                                    totalImpuestos:
                                                                                        arrayImpuestos[index].totalImpuestos +
                                                                                        valueImpuestos.totalImpuestos,
                                                                                    baseImpuesto:
                                                                                        arrayImpuestos[index].baseImpuesto +
                                                                                        valueImpuestos.baseImpuesto,
                                                                                    descripcionFactura:
                                                                                        valueImpuestos.descripcionFactura,
                                                                                    tasaCuota:
                                                                                        valueImpuestos.tasaCuota,
                                                                                    impuesto:
                                                                                        valueImpuestos.impuesto,
                                                                                    montoImpuesto:
                                                                                        valueImpuestos.montoImpuesto,
                                                                                    local: valueImpuestos.local,
                                                                                };
                                                                                arrayImpuestos.splice(index, 1, newItem);
                                                                            } else {
                                                                                arrayImpuestos.push({
                                                                                    tasaCuota: valueImpuestos.tasaCuota,
                                                                                    impuesto: valueImpuestos.impuesto,
                                                                                    local: valueImpuestos.local,
                                                                                    montoImpuesto: valueImpuestos.montoImpuesto,
                                                                                    baseImpuesto: valueImpuestos.baseImpuesto,
                                                                                    descripcionFactura: valueImpuestos.descripcionFactura,
                                                                                    totalImpuestos: valueImpuestos.totalImpuestos,
                                                                                });
                                                                            }
                                                                            return null;
                                                                        });
                                                                        if (value.arrayRetenciones) {
                                                                            value.arrayRetenciones.map((valueRetenciones) => {
                                                                                let index = arrayRetenciones.findIndex(
                                                                                    (valueRetencionesAnterios) =>
                                                                                        valueRetencionesAnterios.descripcionFactura ===
                                                                                        valueRetenciones.descripcionFactura
                                                                                        &&
                                                                                        valueRetencionesAnterios.tasaCuota ===
                                                                                        valueRetenciones.tasaCuota
                                                                                        &&
                                                                                        valueRetencionesAnterios.impuesto ===
                                                                                        valueRetenciones.impuesto
                                                                                );
                                                                                cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                                                                                if (index !== -1) {
                                                                                    let newItem = {
                                                                                        totalRetenciones:
                                                                                            arrayRetenciones[index].totalRetenciones +
                                                                                            valueRetenciones.totalRetenciones,
                                                                                        baseRetencion:
                                                                                            arrayRetenciones[index].baseRetencion +
                                                                                            valueRetenciones.baseRetencion,
                                                                                        descripcionFactura:
                                                                                            valueRetenciones.descripcionFactura,
                                                                                        tasaCuota:
                                                                                            valueRetenciones.tasaCuota,
                                                                                        impuesto:
                                                                                            valueRetenciones.impuesto,
                                                                                        montoRetencion:
                                                                                            valueRetenciones.montoRetencion,
                                                                                        local: valueRetenciones.local,
                                                                                    };
                                                                                    arrayRetenciones.splice(index, 1, newItem);
                                                                                } else {
                                                                                    arrayRetenciones.push({
                                                                                        tasaCuota: valueRetenciones.tasaCuota,
                                                                                        impuesto: valueRetenciones.impuesto,
                                                                                        montoRetencion: valueRetenciones.montoRetencion,
                                                                                        local: valueRetenciones.local,
                                                                                        baseRetencion: valueRetenciones.baseRetencion,
                                                                                        descripcionFactura: valueRetenciones.descripcionFactura,
                                                                                        totalRetenciones: valueRetenciones.totalRetenciones,
                                                                                    });
                                                                                }
                                                                                return null;
                                                                            });
                                                                        }
                                                                    }
                                                                }
                                                                return null;
                                                            });
                                                            arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
                                                                total += round2Decimals(valueImpuesto.totalImpuestos)
                                                                return {
                                                                    ...valueImpuesto,
                                                                    totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
                                                                }
                                                            })
                                                            if (this.state.totalPagar !== (total - cuentasCliente)) {
                                                                this.setState({ totalPagar: (total - cuentasCliente) });
                                                            }
                                                            const totalCantidadInsumos = arrayInsumos.reduce(
                                                                (suma, insumo) => suma + (Number(insumo?.cantidad) || 0),
                                                                0
                                                            );
                                                            return (
                                                                <table className="table" style={{ marginTop: 0 }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th
                                                                                className="th-totales"
                                                                                style={{ width: "50%" }}
                                                                            >
                                                                                Total Insumos
                                                                            </th>
                                                                            <td
                                                                                className="td-totales-right"
                                                                                style={{ width: "50%" }}
                                                                            >
                                                                                {totalCantidadInsumos}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th
                                                                                className="th-totales"
                                                                                style={{ width: "50%" }}
                                                                            >
                                                                                Subtotal
                                                                            </th>
                                                                            <td
                                                                                className="td-totales-right"
                                                                                style={{ width: "50%" }}
                                                                            >
                                                                                {dineroDisabledMask(subtotal)}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    {arrayImpuestos.map((valueArray) => (
                                                                        <tbody key={valueArray.descripcionFactura}>
                                                                            <tr>
                                                                                <th className="th-totales">
                                                                                    {valueArray.descripcionFactura}
                                                                                </th>
                                                                                <td className="td-totales-right">
                                                                                    {dineroDisabledMask(
                                                                                        valueArray.totalImpuestos
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    ))}
                                                                    <tbody>
                                                                        <tr>
                                                                            <th className="th-totales">Total</th>
                                                                            <td className="td-totales-right">
                                                                                {dineroDisabledMask(total)}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    {arrayRetenciones.map((value) => (
                                                                        <tbody key={value.descripcionFactura}>
                                                                            <tr>
                                                                                <th className="th-totales">
                                                                                    {value.descripcionFactura}
                                                                                </th>
                                                                                <td className="td-totales-right">
                                                                                    {dineroDisabledMask(value.totalRetenciones)}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    ))}
                                                                    <tbody>
                                                                        <tr>
                                                                            <th className="th-totales">Total a Pagar</th>
                                                                            <td className="td-totales-right">
                                                                                {dineroDisabledMask(total - cuentasCliente)}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            );
                                                        }}
                                                    </FormItem>
                                                    )};
                                                })()}
                                            actionButtons={(<>
                                            <ButtonItem hotkey="shift+c" type="primary" rojoB onClick={this.atras.bind(this)}>Cancelar</ButtonItem>
                                            <ButtonItem hotkey="shift+a" htmlType="submit" type="primary" verdeB>Agregar</ButtonItem></>)}
                                        />
                                    );
                                }}
                            </FormItem>
                            {/* Hidden fields for form submission */}
                            <FormItem name="observaciones" hidden><input /></FormItem>
                            <FormItem name="observaciones2" hidden><input /></FormItem>
                            <FormItem name="imprimirObservaciones" valuePropName="checked" hidden><input type="checkbox" /></FormItem>
                            <FormItem name="deshabilitarBanco" valuePropName="checked" hidden><input type="checkbox" /></FormItem>
                        </Form>
                    </Spin>
                </div>
                                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    onOk={() => {
                        this.setState({ modalConfirmacion: false });
                        this.onFinish(this.state.valuesForm);
                    }}
                    spinning={false}
                    footer
                >
                    <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
                </ModalItem>
                <ElegirTipoDeCliente
                    visible={this.state.modalElegirTipoDeCliente}
                    id={this.state.modalElegirTipoDeClienteId}
                    nombre={this.state.modalElegirTipoDeClienteNombre}
                    cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente.bind(this)}
                />
                <MandarCorreoEmbarque
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreoEmbarque={this.cerrarMandarCorreoEmbarque.bind(this)}
                    history={this.props.history}
                />
                <AgregarCliente
                    visible={this.state.modalAgregar}
                    cerrarModal={this.cerrarAgregarCliente}
                />
                {!this.props.desactivarCargaExcelInsumosVentas && (
                <ModalCargarExcelInsumos
                    visible={this.state.modalCargarExcelVisible}
                    onCancel={() => this.setState({ modalCargarExcelVisible: false })}
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    nombreDocumento="Embarque"
                    clienteId={this.formRef.current?.getFieldValue("clienteId")}
                    precioId={this.formRef.current?.getFieldValue("precioId")}
                    hayInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length > 0}
                    cantidadInsumosCapturados={(this.formRef.current?.getFieldValue("insumos") || []).length}
                    permitirReemplazar={!this.hayRenglonesConPedidoAsignado()}
                    onConfirmar={this.cargarInsumosDesdeExcel}
                />
                )}
                <ElegirLeyenda
                    visible={this.state.modalLeyenda}
                    cerrarElegirLeyenda={this.cerrarLeyenda.bind(this)}
                    leyenda={this.state.modalLeyendaLeyenda}
                    leyendasPasadas={this.state.modalLeyendaLeyendasPasadas}
                    clienteIdActual={this.state.clienteIdActual}
                    nombreClienteActual={this.state.nombreClienteActual}
                />
                <ElegirLotes
                    visible={this.state.modalElegirLotes}
                    cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
                    lotes={this.state.modalElegirLotesLotes}
                    insumoId={this.state.modalElegirLotesInsumoId}
                    proyectoId={this.state.modalElegirLotesProyectoId}
                    clienteId={this.state.modalElegirLotesClienteId}
                    cantidad={this.state.modalElegirLotesCantidad}
                />
                <ElegirAgrupaciones
                    visible={this.state.modalElegirAgrupaciones}
                    cerrarElegirAgrupaciones={this.cerrarElegirAgrupaciones.bind(this)}
                    agrupaciones={this.state.modalElegirAgrupacionesAgrupaciones}
                    insumoId={this.state.modalElegirAgrupacionesInsumoId}
                    proyectoId={this.state.modalElegirAgrupacionesProyectoId}
                    clienteId={this.state.modalElegirAgrupacionesClienteId}
                />
                <ElegirObservaciones
                    visible={this.state.modalObservaciones}
                    cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
                    observaciones={this.state.modalObservacionesObservaciones}
                    observacionesPasadas={this.state.modalObservacionesObservacionesPasadas}
                    observacionesXml={this.state.modalObservacionesObservacionesXml}
                    clienteIdActual={this.state.clienteIdActual}
                    nombreClienteActual={this.state.nombreClienteActual}
                />
                <VerInsumo
                    visible={this.state.modalVerInsumo}
                    cerrarVerInsumo={(precio) => this.cerrarVerInsumo(precio)}
                    id={this.state.modalVerInsumoId}
                    precioId={this.state.modalVerInsumoPrecioId}
                    tipoDeCambio={this.state.modalVerInsumoTipoDeCambio}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <AgregarCirugia
                    visible={this.state.modalAgregarCirugia}
                    cerrarAgregarCirugia={this.cerrarAgregarCirugia.bind(this)}
                />
                <AgregarDoctor
                    visible={this.state.modalAgregarDoctor}
                    cerrarAgregarDoctor={this.cerrarAgregarDoctor.bind(this)}
                />
                <AgregarPaciente
                    visible={this.state.modalAgregarPaciente}
                    cerrarAgregarPaciente={this.cerrarAgregarPaciente.bind(this)}
                />
                <ElegirPedidoInsumo
                    visible={this.state.modalElegirPedido}
                    cerrarElegirPedido={this.cerrarElegirPedido.bind(this)}
                    insumoId={this.state.modalElegirPedidoInsumoId}
                    clienteId={this.formRef.current?.getFieldValue("clienteId")}
                    cantidad={this.state.modalElegirPedidoCantidad}
                    pedidosOrigen={this.state.modalElegirPedidoPedidosOrigen}
                />
                <DetalleInsumoModal
                    visible={this.state.modalDetalleInsumoVisible}
                    onClose={this.cerrarDetalleInsumo}
                    insumoId={this.state.insumoSeleccionadoDetalle.id}
                    nombreInsumo={this.state.insumoSeleccionadoDetalle.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <DisponibilidadInsumoModal
                    visible={this.state.modalDisponibilidadVisible}
                    onClose={this.cerrarDisponibilidad.bind(this)}
                    insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
                    nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                    proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
                />
                <BusquedaAvanzadaInsumosModal
                    visible={this.state.modalBusquedaAvanzadaVisible}
                    onClose={this.cerrarBusquedaAvanzada}
                    onAgregar={this.agregarInsumoDesdeBusqueda}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                    {...this.state.contextoBusquedaAvanzada}
                />
                <HistorialInsumoClienteModal
                    visible={this.state.modalHistorialClienteVisible}
                    onClose={this.cerrarHistorialCliente}
                    insumoId={this.state.insumoSeleccionadoHistorial.id}
                    nombreInsumo={this.state.insumoSeleccionadoHistorial.nombre}
                    clienteId={this.state.insumoSeleccionadoHistorial.clienteId}
                    permitirUsarPrecio={!!this.props.permisoModificarPrecioUnitarioPedidos}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <ModalAutorizacion
                    visible={!!this.state.modalAutorizacion?.visible}
                    permisoId={this.state.modalAutorizacion?.permisoId}
                    contexto={this.state.modalAutorizacion?.contexto}
                    opcionesValor={this.state.objetoPrecios}
                    onAutorizado={this.onAutorizado}
                    onCancel={() => this.setState({ modalAutorizacion: null })}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
        usuarioId: state.user.usuarioId,
        certificada: state.empresa.certificada,
        equipoMedico: state.empresa.equipoMedico,
        complementoDetallista: state.empresa.complementoDetallista,
        autorizacionesRapidas: state.empresa.autorizacionesRapidas,
        quitarImpuestosOpcionalVentas: state.empresa.quitarImpuestosOpcionalVentas,
        desactivarCargaExcelInsumosVentas: state.empresa.desactivarCargaExcelInsumosVentas,
        escuela: state.empresa.escuela,
        permisoVenderCredito:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6419"
            )?.activado,
        permisoModificarMoneda:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641a"
            )?.activado,
        permisoModificarListaPrecios:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6420"
            )?.activado,
        permisoModificarPrecioUnitario:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641b"
            )?.activado,
        permisoModificarDescuento:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641c"
            )?.activado,
        permisoModificarDescuentosPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6424"
            )?.activado,
        permisoModificarListaPreciosPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6427"
            )?.activado,
        permisoModificarMonedaPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6422"
            )?.activado,
        permisoModificarPrecioUnitarioPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6423"
            )?.activado,
        permisoVenderCreditoPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6421"
            )?.activado,
    };
};

export default connect(mapStateToProps)(AgregarEmbarque);
